import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";




function OrbisInstitutionUXStyle() {
    return (
        <style>{`
            .institution-orbis-pro,
            .institution-orbis-pro.page-container,
            .institution-orbis-pro .page-container{
                min-height:100vh;
                background:#041426!important;
                color:#f5fbff!important;
                padding:24px!important;
            }

            .institution-orbis-pro > .page-header,
            .institution-orbis-pro .page-header:first-child{
                max-width:1500px;
                margin:0 auto 24px auto;
                background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%)!important;
                border:1px solid rgba(11,93,140,.8)!important;
                box-shadow:0 20px 45px rgba(0,0,0,.28)!important;
                border-radius:28px!important;
                padding:28px!important;
            }

            .institution-orbis-pro .page-title{
                color:#fff!important;
                font-size:36px!important;
                line-height:1.05!important;
                font-weight:900!important;
                letter-spacing:-.03em!important;
                margin:0!important;
            }

            .institution-orbis-pro .page-subtitle{
                color:#d7e8f6!important;
                font-size:14px!important;
                line-height:1.65!important;
                max-width:850px!important;
                margin-top:10px!important;
            }

            .institution-orbis-pro .page-header::before{
                content:"CRM / Institución";
                display:inline-flex;
                align-items:center;
                gap:12px;
                color:#d4af37;
                text-transform:uppercase;
                letter-spacing:.24em;
                font-size:12px;
                font-weight:800;
                margin-bottom:12px;
            }

            .institution-orbis-pro .card,
            .institution-orbis-pro .panel,
            .institution-orbis-pro .section,
            .institution-orbis-pro .module-card,
            .institution-orbis-pro .bg-white,
            .institution-orbis-pro [class*="rounded-xl"],
            .institution-orbis-pro [class*="rounded-2xl"]{
                background:#04192b!important;
                border-color:#0b4d78!important;
                color:#f5fbff!important;
                box-shadow:0 12px 30px rgba(0,0,0,.24)!important;
            }

            .institution-orbis-pro .card,
            .institution-orbis-pro .panel,
            .institution-orbis-pro .section,
            .institution-orbis-pro .module-card{
                max-width:1500px;
                margin-left:auto;
                margin-right:auto;
                border-radius:24px!important;
                overflow:hidden;
            }

            .institution-orbis-pro .card-header-inline,
            .institution-orbis-pro .card-header,
            .institution-orbis-pro .section-header,
            .institution-orbis-pro .panel-header{
                background:#031425!important;
                border-bottom:1px solid #0b4d78!important;
                color:#f5fbff!important;
            }

            .institution-orbis-pro .card-title,
            .institution-orbis-pro h1,
            .institution-orbis-pro h2,
            .institution-orbis-pro h3,
            .institution-orbis-pro h4,
            .institution-orbis-pro .font-semibold,
            .institution-orbis-pro strong{
                color:#fff!important;
            }

            .institution-orbis-pro .card-title,
            .institution-orbis-pro .section-title{
                color:#d4af37!important;
                text-transform:uppercase;
                letter-spacing:.18em;
                font-size:11px!important;
            }

            .institution-orbis-pro p,
            .institution-orbis-pro small,
            .institution-orbis-pro span,
            .institution-orbis-pro div,
            .institution-orbis-pro .text-gray-500,
            .institution-orbis-pro .text-gray-600,
            .institution-orbis-pro .text-slate-500,
            .institution-orbis-pro .text-slate-600{
                color:inherit;
            }

            .institution-orbis-pro .text-gray-500,
            .institution-orbis-pro .text-gray-600,
            .institution-orbis-pro .text-slate-500,
            .institution-orbis-pro .text-slate-600{
                color:#9fc4df!important;
            }

            .institution-orbis-pro label,
            .institution-orbis-pro .form-field label{
                color:#8fb9da!important;
                font-weight:700!important;
                text-transform:uppercase;
                letter-spacing:.12em;
                font-size:11px!important;
            }

            .institution-orbis-pro input,
            .institution-orbis-pro select,
            .institution-orbis-pro textarea{
                background:#0b2740!important;
                border:1px solid #0b5f91!important;
                color:#fff!important;
                border-radius:12px!important;
                padding:9px 11px!important;
            }

            .institution-orbis-pro input::placeholder,
            .institution-orbis-pro textarea::placeholder{
                color:#7ea8c7!important;
            }

            .institution-orbis-pro input:focus,
            .institution-orbis-pro select:focus,
            .institution-orbis-pro textarea:focus{
                border-color:#d4af37!important;
                box-shadow:0 0 0 2px rgba(212,175,55,.18)!important;
                outline:none!important;
            }

            .institution-orbis-pro select option{
                background:#061a2f!important;
                color:#fff!important;
            }

            .institution-orbis-pro .btn,
            .institution-orbis-pro button{
                border-radius:999px!important;
                font-weight:700!important;
                border-color:#24537a!important;
            }

            .institution-orbis-pro .btn-secondary,
            .institution-orbis-pro button:not(.btn-primary):not(.unstyled){
                background:#0b2740!important;
                color:#f5fbff!important;
                border:1px solid #24537a!important;
            }

            .institution-orbis-pro .btn-secondary:hover,
            .institution-orbis-pro button:not(.btn-primary):not(.unstyled):hover{
                background:#10324f!important;
                border-color:#d4af37!important;
            }

            .institution-orbis-pro .btn-primary,
            .institution-orbis-pro .bg-cani-primary{
                background:#d4af37!important;
                color:#081a2b!important;
                border-color:#d4af37!important;
                font-weight:800!important;
            }

            .institution-orbis-pro .badge,
            .institution-orbis-pro [class*="badge"],
            .institution-orbis-pro .alert-info{
                border:1px solid #24537a!important;
                background:#0f2d48!important;
                color:#d9e8f5!important;
            }

            .institution-orbis-pro table{
                border-collapse:separate!important;
                border-spacing:0!important;
                background:#061a2f!important;
            }

            .institution-orbis-pro table thead th{
                position:sticky;
                top:0;
                z-index:10;
                background:#061a2f!important;
                color:#8fb9da!important;
                border-bottom:1px solid #24587c!important;
                text-transform:uppercase;
                letter-spacing:.13em;
            }

            .institution-orbis-pro table tbody tr{
                background:#08233d!important;
                transition:background .18s ease, box-shadow .18s ease;
            }

            .institution-orbis-pro table tbody tr:nth-child(even){
                background:#092a49!important;
            }

            .institution-orbis-pro table tbody tr:hover{
                background:rgba(56,189,248,.075)!important;
                box-shadow:inset 3px 0 0 #d4af37;
            }

            .institution-orbis-pro table tbody td{
                border-top:1px solid #24587c!important;
                background:transparent!important;
                color:#f5fbff!important;
            }

            .institution-orbis-pro .grid-hover-list > li{
                background:#08233d!important;
                border-color:#24587c!important;
                color:#f5fbff!important;
            }

            .institution-orbis-pro .grid-hover-list > li:nth-child(even){
                background:#092a49!important;
            }

            .institution-orbis-pro .grid-hover-list > li:hover{
                background:rgba(56,189,248,.075)!important;
                box-shadow:inset 3px 0 0 #d4af37;
            }

            .institution-orbis-pro [style*="background: rgb(255, 255, 255)"],
            .institution-orbis-pro [style*="background: #ffffff"],
            .institution-orbis-pro [style*="background:#ffffff"],
            .institution-orbis-pro [style*="background: white"],
            .institution-orbis-pro [style*="background:white"]{
                background:#04192b!important;
            }

            .institution-orbis-pro [style*="border: 1px solid #e5e7eb"],
            .institution-orbis-pro [style*="borderLeft: 1px solid #e5e7eb"]{
                border-color:#0b4d78!important;
            }

            .institution-orbis-pro ::-webkit-scrollbar{height:10px;width:10px}
            .institution-orbis-pro ::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .institution-orbis-pro ::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .institution-orbis-pro ::-webkit-scrollbar-thumb:hover{background:#d4af37}


            .institution-orbis-pro{
                max-width:none!important;
            }

            .institution-orbis-pro .page-header,
            .institution-orbis-pro > .page-header{
                max-width:1500px!important;
                margin:0 auto 24px auto!important;
                background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%)!important;
                border:1px solid rgba(11,93,140,.8)!important;
                box-shadow:0 20px 45px rgba(0,0,0,.28)!important;
                border-radius:28px!important;
                padding:28px!important;
            }

            .institution-orbis-pro .page-header-actions .btn,
            .institution-orbis-pro .form-actions .btn{
                border:1px solid #24537a!important;
                background:#0b2740!important;
                color:#f5fbff!important;
                border-radius:999px!important;
                padding:9px 13px!important;
                font-size:12px!important;
                font-weight:700!important;
            }

            .institution-orbis-pro .page-header-actions .btn:hover,
            .institution-orbis-pro .form-actions .btn:hover{
                background:#10324f!important;
                border-color:#d4af37!important;
            }

            .institution-orbis-pro .form-actions .btn-primary,
            .institution-orbis-pro .page-header-actions .btn-primary,
            .institution-orbis-pro .btn-primary{
                background:#d4af37!important;
                color:#081a2b!important;
                border-color:#d4af37!important;
            }

            .institution-orbis-pro .card{
                max-width:1500px!important;
                margin-left:auto!important;
                margin-right:auto!important;
                border:1px solid rgba(11,93,140,.82)!important;
                background:#04192b!important;
                color:#f5fbff!important;
                box-shadow:0 12px 30px rgba(0,0,0,.24)!important;
                border-radius:24px!important;
                overflow:hidden!important;
            }

            .institution-orbis-pro .card-header-inline{
                background:#031425!important;
                border-bottom:1px solid #0b4d78!important;
                padding:16px 20px!important;
            }

            .institution-orbis-pro .card-title{
                color:#d4af37!important;
                text-transform:uppercase!important;
                letter-spacing:.18em!important;
                font-size:11px!important;
                font-weight:800!important;
            }

            .institution-orbis-pro .form-grid{
                padding:20px!important;
            }

            .institution-orbis-pro .form-field{
                color:#f5fbff!important;
            }

            .institution-orbis-pro .form-field label{
                color:#8fb9da!important;
                font-weight:800!important;
                text-transform:uppercase!important;
                letter-spacing:.12em!important;
                font-size:11px!important;
            }

            .institution-orbis-pro .badge{
                border:1px solid #0ea5e9!important;
                background:#0b2740!important;
                color:#d9f4ff!important;
                border-radius:999px!important;
                padding:5px 9px!important;
                font-size:10px!important;
                font-weight:800!important;
            }

            
            .institution-orbis-pro .institution-wide-card{
                grid-column:1 / -1!important;
                width:100%!important;
                max-width:none!important;
                justify-self:stretch!important;
                margin-left:0!important;
                margin-right:0!important;
            }

            .institution-orbis-pro .institution-wide-card .table-wrapper{
                width:100%!important;
            }

            .institution-orbis-pro .institution-wide-card table{
                width:100%!important;
                min-width:980px!important;
            }

            .institution-orbis-pro .institution-actions-row{
                display:flex;
                align-items:center;
                gap:8px;
                flex-wrap:wrap;
            }

            .institution-orbis-pro .institution-link-strong{
                color:#7dd3fc!important;
                font-weight:900!important;
                text-decoration:none!important;
            }

            .institution-orbis-pro .institution-link-strong:hover{
                color:#d4af37!important;
                text-decoration:underline!important;
            }

            .institution-orbis-pro .table-wrapper{
                background:#04192b!important;
                border-color:#0b4d78!important;
                overflow:auto!important;
            }

            .institution-orbis-pro .alert-info{
                background:#0b2740!important;
                border:1px dashed #0b4d78!important;
                color:#d9f4ff!important;
                border-radius:18px!important;
                padding:14px!important;
            }

            .institution-orbis-pro a,
            .institution-orbis-pro .link-button{
                color:#7dd3fc!important;
            }

            .institution-orbis-pro a:hover,
            .institution-orbis-pro .link-button:hover{
                color:#d4af37!important;
            }

            .institution-orbis-pro div[style*="color: #111827"],
            .institution-orbis-pro td[style*="color: #111827"],
            .institution-orbis-pro span[style*="color: #111827"],
            .institution-orbis-pro div[style*="color:#111827"],
            .institution-orbis-pro td[style*="color:#111827"],
            .institution-orbis-pro span[style*="color:#111827"]{
                color:#f5fbff!important;
            }

            .institution-orbis-pro div[style*="color: #666"],
            .institution-orbis-pro td[style*="color: #666"],
            .institution-orbis-pro span[style*="color: #666"],
            .institution-orbis-pro div[style*="color:#666"],
            .institution-orbis-pro td[style*="color:#666"],
            .institution-orbis-pro span[style*="color:#666"]{
                color:#9fc4df!important;
            }

            .institution-orbis-pro div[style*="color: #6b7280"],
            .institution-orbis-pro td[style*="color: #6b7280"],
            .institution-orbis-pro span[style*="color: #6b7280"],
            .institution-orbis-pro div[style*="color:#6b7280"],
            .institution-orbis-pro td[style*="color:#6b7280"],
            .institution-orbis-pro span[style*="color:#6b7280"]{
                color:#9fc4df!important;
            }

            .institution-orbis-pro div[style*="color: #9ca3af"],
            .institution-orbis-pro span[style*="color: #9ca3af"],
            .institution-orbis-pro td[style*="color: #9ca3af"]{
                color:#8fb9da!important;
            }

            .institution-orbis-pro div[style*="border: 1px solid #e5e7eb"],
            .institution-orbis-pro img[style*="border: 1px solid #e5e7eb"]{
                border-color:#24587c!important;
                background:#0b2740!important;
            }

            .institution-orbis-pro div[style*="background: #ffffff"],
            .institution-orbis-pro div[style*="background:#ffffff"],
            .institution-orbis-pro div[style*="background: white"],
            .institution-orbis-pro div[style*="background:white"]{
                background:#04192b!important;
            }

            .institution-orbis-pro div[style*="borderLeft: 1px solid #e5e7eb"],
            .institution-orbis-pro div[style*="border-left: 1px solid #e5e7eb"]{
                border-left-color:#0b4d78!important;
            }

            .institution-orbis-pro .drawer,
            .institution-orbis-pro .modal{
                background:#04192b!important;
                color:#f5fbff!important;
            }


            .institution-orbis-pro .form-grid,
            .institution-orbis-pro .form-grid div,
            .institution-orbis-pro .form-grid p,
            .institution-orbis-pro .form-grid span,
            .institution-orbis-pro .form-grid li,
            .institution-orbis-pro .form-grid a{
                color:#d7e8f6!important;
            }

            .institution-orbis-pro .form-field > div,
            .institution-orbis-pro .form-field div:not(.form-actions){
                color:#d7e8f6!important;
            }

            .institution-orbis-pro .form-field.full-width > div{
                color:#d7e8f6!important;
                line-height:1.65!important;
            }

            .institution-orbis-pro .form-field.full-width label,
            .institution-orbis-pro .form-field label{
                color:#8fd8ff!important;
                opacity:1!important;
            }

            .institution-orbis-pro .profile-text,
            .institution-orbis-pro .institution-text{
                color:#d7e8f6!important;
            }

            .institution-orbis-pro [style*="color: rgb(17, 24, 39)"],
            .institution-orbis-pro [style*="color:#111827"],
            .institution-orbis-pro [style*="color: #111827"],
            .institution-orbis-pro [style*="color:rgb(17, 24, 39)"]{
                color:#d7e8f6!important;
            }

            .institution-orbis-pro [style*="color: rgb(102, 102, 102)"],
            .institution-orbis-pro [style*="color:#666"],
            .institution-orbis-pro [style*="color: #666"],
            .institution-orbis-pro [style*="color:rgb(102, 102, 102)"]{
                color:#9fc4df!important;
            }

            .institution-orbis-pro [style*="color: rgb(107, 114, 128)"],
            .institution-orbis-pro [style*="color:#6b7280"],
            .institution-orbis-pro [style*="color: #6b7280"],
            .institution-orbis-pro [style*="color:rgb(107, 114, 128)"]{
                color:#9fc4df!important;
            }

            .institution-orbis-pro .card .form-grid{
                background:rgba(8,35,61,.45)!important;
            }

            .institution-orbis-pro .card .form-field{
                border-bottom:1px solid rgba(36,88,124,.28);
                padding-bottom:12px;
            }

            .institution-orbis-pro .card .form-field:last-child{
                border-bottom:none;
            }

            @media(max-width:768px){
                .institution-orbis-pro{padding:12px!important}
                .institution-orbis-pro .page-header{padding:20px!important}
                .institution-orbis-pro .page-title{font-size:30px!important}
            }
        `}</style>
    );
}

function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table {
                border-collapse: separate !important;
                border-spacing: 0 !important;
                background: #061a2f !important;
            }

            .grid-rows-pro table thead th {
                position: sticky;
                top: 0;
                z-index: 10;
                background: #061a2f !important;
                color: #8fb9da !important;
                border-bottom: 1px solid #24587c !important;
                text-transform: uppercase;
                letter-spacing: .13em;
            }

            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease, box-shadow 0.18s ease;
                background: #08233d !important;
            }

            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #092a49 !important;
            }

            .grid-rows-pro table tbody tr:hover {
                background: rgba(56,189,248,.075) !important;
                box-shadow: inset 3px 0 0 #d4af37;
            }

            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #f5fbff !important;
                vertical-align: top;
                border-top: 1px solid #24587c !important;
                background: transparent !important;
            }

            .grid-rows-pro table tbody td .grid-row-main {
                font-weight: 700;
                color: #ffffff !important;
            }

            .grid-rows-pro table tbody td .grid-row-sub {
                color: #9fc4df !important;
                font-size: 12px;
            }

            .grid-rows-pro ul.grid-hover-list > li {
                transition: background 0.18s ease, box-shadow 0.18s ease;
                background: #08233d !important;
                border-color: #24587c !important;
                color: #f5fbff !important;
            }

            .grid-rows-pro ul.grid-hover-list > li:nth-child(even) {
                background: #092a49 !important;
            }

            .grid-rows-pro ul.grid-hover-list > li:hover {
                background: rgba(56,189,248,.075) !important;
                box-shadow: inset 3px 0 0 #d4af37;
            }
        `}</style>
    );
}


function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return { ...extra, Authorization: `Bearer ${token}`, "X-CANI-AUTH": token };
}

async function safeJsonFetch(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();
    if (!text) throw new Error(`Respuesta vacía (${res.status}) en ${url}`);
    let data;
    try {
        data = JSON.parse(text);
    } catch {
        throw new Error(`Respuesta no-JSON (${res.status}) en ${url}: ${text.slice(0, 250)}`);
    }
    if (!res.ok) throw new Error(data?.error || `HTTP ${res.status} en ${url}`);
    return data;
}

function fmtDateISO(d) {
    if (!d) return "";
    const value = typeof d === "string" ? d : d.toISOString();
    const parsed = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(parsed.getTime())) return String(value).slice(0, 10);

    const months = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
    const yyyy = parsed.getFullYear();
    const mmm = months[parsed.getMonth()];
    const dd = String(parsed.getDate()).padStart(2, "0");

    return `${dd}-${mmm}-${yyyy}`;
}

function fileIconByMime(mime) {
    if (!mime) return "📄";
    if (mime.includes("pdf")) return "📕";
    if (mime.includes("word")) return "🟦";
    if (mime.includes("excel") || mime.includes("spreadsheet")) return "🟩";
    if (mime.includes("powerpoint") || mime.includes("presentation")) return "🟧";
    if (mime.startsWith("image/")) return "🖼️";
    return "📄";
}

function buildEventSummary({ date, title, location, reason, tags }) {
    const parts = [];
    if (date) parts.push(`El día ${date}`);
    parts.push(`CLIP realizó ${title || "un evento"}${location ? ` en ${location}` : ""}.`);
    if (reason) parts.push(`El objetivo fue ${reason}.`);
    if (tags) parts.push(`Temas: ${tags}.`);
    parts.push("Seguimos fortaleciendo alianzas para impulsar el desarrollo tecnológico e industrial de la región.");
    return parts.join(" ");
}

class PageErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }
    static getDerivedStateFromError(err) {
        return { hasError: true, message: err?.message || String(err) };
    }
    componentDidCatch(err, info) {
        console.error("InstitutionPage crashed:", err, info);
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <MainLayout>
                <OrbisInstitutionUXStyle />
                <GridRowsProStyle />
                <div className="institution-orbis-pro page-container grid-rows-pro">
                    <div className="card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>Se produjo un error en la interfaz</h3>
                            <button className="btn btn-primary" onClick={() => window.location.reload()}>
                                Recargar
                            </button>
                        </div>
                        <div className="alert-info" style={{ whiteSpace: "pre-wrap" }}>
                            {this.state.message}
                        </div>
                    </div>
                </div>
            </MainLayout>
        );
    }
}

function Drawer({ open, title, subtitle, onClose, children }) {
    if (!open) return null;
    return (
        <>
            <div
                onClick={onClose}
                style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.35)", zIndex: 1000 }}
            />
            <div
                style={{
                    position: "fixed",
                    right: 0,
                    top: 0,
                    height: "100vh",
                    width: "min(980px, 94vw)",
                    background: "#ffffff",
                    borderLeft: "1px solid #e5e7eb",
                    zIndex: 1100,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        padding: "1rem 1.25rem",
                        borderBottom: "1px solid #e5e7eb",
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 12,
                    }}
                >
                    <div>
                        <div style={{ fontWeight: 700, fontSize: "1.05rem" }}>{title}</div>
                        {subtitle ? <div style={{ fontSize: "0.9rem", color: "#666" }}>{subtitle}</div> : null}
                    </div>
                    <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                </div>

                <div style={{ padding: "1rem 1.25rem", overflow: "auto" }}>{children}</div>
            </div>
        </>
    );
}

function Modal({ open, title, subtitle, onClose, children, size = "normal" }) {
    if (!open) return null;

    const modalWidth = size === "wide"
        ? "min(1280px, 98vw)"
        : "min(860px, 96vw)";

    return (
        <>
            <div style={{ position: "fixed", inset: 0, background: "rgba(2,6,23,0.45)", zIndex: 2000 }} onClick={onClose} />
            <div style={{ position: "fixed", inset: 0, zIndex: 2100, display: "grid", placeItems: "center", padding: 16 }}>
                <div className="card" style={{ width: modalWidth, maxHeight: "92vh", overflow: "auto" }}>
                    <div className="card-header-inline" style={{ alignItems: "center" }}>
                        <div>
                            <h3 className="card-title" style={{ margin: 0 }}>{title}</h3>
                            {subtitle ? <div style={{ fontSize: 12, color: "#9fc4df" }}>{subtitle}</div> : null}
                        </div>
                        <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                    <div style={{ paddingTop: 12 }}>{children}</div>
                </div>
            </div>
        </>
    );
}

function Field({ label, children, full }) {
    return (
        <div className={`form-field ${full ? "full-width" : ""}`}>
            <label>{label}</label>
            {children}
        </div>
    );
}

export default function InstitutionPage() {
    return (
        <PageErrorBoundary>
            <InstitutionPageInner />
        </PageErrorBoundary>
    );
}

function InstitutionPageInner() {
    const [searchParams, setSearchParams] = useSearchParams();

    const panelParam = searchParams.get("panel");
    const industryIdParam = searchParams.get("industry_id");
    const docIdParam = searchParams.get("doc_id");
    const roleIdParam = searchParams.get("role_id");
    const eventIdParam = searchParams.get("event_id");

    const [modal, setModal] = useState(null);

    const [loading, setLoading] = useState(true);
    const [toast, setToast] = useState(null);

    const [profile, setProfile] = useState(null);
    const [profileEditDraft, setProfileEditDraft] = useState(null);
    const [industries, setIndustries] = useState([]);
    const [docs, setDocs] = useState([]);
    const [roles, setRoles] = useState([]);
    const [roleFilters, setRoleFilters] = useState({
        q: "",
        group: "",
        type: "",
        status: "",
        company: "",
        board: "",
    });
    const [roleSort, setRoleSort] = useState({ key: "sort_order", direction: "asc" });
    const [events, setEvents] = useState([]);

    const [industrySectionCounts, setIndustrySectionCounts] = useState({});
    const [roleAssetsSummary, setRoleAssetsSummary] = useState({});

    const [roleAssets, setRoleAssets] = useState([]);
    const [roleAssetsLoading, setRoleAssetsLoading] = useState(false);
    const [roleAssetFiles, setRoleAssetFiles] = useState([]);
    const [roleAssetTitle, setRoleAssetTitle] = useState("");

    const ROLE_GROUPS = [
        "Presidencia",
        "Vicepresidencia",
        "Consejo",
        "Comité",
        "Dirección",
        "Administración",
        "Enlace Gobierno",
        "Enlace Universidad",
        "Afiliaciones",
        "Proyectos",
        "Otro",
    ];

    const INSTITUTION_ROLE_TYPES = [
        ["presidencia", "Presidencia"],
        ["vicepresidencia", "Vicepresidencia"],
        ["consejo", "Consejo"],
        ["comite", "Comité"],
        ["representante", "Representante"],
        ["administrativo", "Administrativo"],
        ["operativo", "Operativo"],
        ["enlace", "Enlace"],
        ["otro", "Otro"],
    ];

    const INSTITUTION_ROLE_STATUS = [
        ["activo", "Activo"],
        ["inactivo", "Inactivo"],
        ["histórico", "Histórico"],
        ["suplente", "Suplente"],
    ];

    const DOC_CATEGORIES = [
        "Actas",
        "Estatutos",
        "Reglamentos",
        "Manuales",
        "Presentaciones",
        "Convenios",
        "Formatos",
        "Reportes",
        "Evidencias",
        "Otros",
    ];

    const EVENT_TYPES = [
        "Reunión",
        "Foro",
        "Conferencia",
        "Firma de convenio",
        "Networking",
        "Visita",
        "Mesa de trabajo",
        "Evento",
        'Asamblea',
        'Consejo Nacional',
        "Otro",
    ];

    const PHOTO_TYPES = [
        "general",
        "escenario",
        "asistentes",
        "networking",
        "prensa",
        "firma",
        "panel",
    ];

    const [industryDraft, setIndustryDraft] = useState({ name: "", description: "", sort_order: 0 });
    const [industryEditDraft, setIndustryEditDraft] = useState(null);

    const [docDraft, setDocDraft] = useState({ category: "Otros", title: "", description: "", sort_order: 0 });
    const [docFile, setDocFile] = useState(null);

    const blankRoleDraft = {
        affiliate_company_id: "",
        contact_id: "",
        role_group: "Otro",
        role_title: "",
        role_type: "representante",
        committee_area: "",
        period_start: "",
        period_end: "",
        status: "activo",
        is_board_member: 0,
        person_name: "",
        email: "",
        phone: "",
        organization: "",
        notes: "",
        sort_order: 0,
        plan_doc_path: "",
        certificate_image_path: "",
    };

    const [roleDraft, setRoleDraft] = useState(blankRoleDraft);
    const [roleEditDraft, setRoleEditDraft] = useState(null);

    const [affiliatedCompanies, setAffiliatedCompanies] = useState([]);
    const [roleCompanyContacts, setRoleCompanyContacts] = useState([]);
    const [roleCompanyContactsLoading, setRoleCompanyContactsLoading] = useState(false);

    const [rolePlanFile, setRolePlanFile] = useState(null);
    const [roleCertFile, setRoleCertFile] = useState(null);

    const [eventEditDraft, setEventEditDraft] = useState(null);

    const [eventPhotos, setEventPhotos] = useState([]);
    const [eventPhotoFiles, setEventPhotoFiles] = useState([]);
    const [eventPhotoCaption, setEventPhotoCaption] = useState("");
    const [eventPhotoType, setEventPhotoType] = useState("general");

    const [industrySections, setIndustrySections] = useState([]);
    const [sectionsLoading, setSectionsLoading] = useState(false);
    const [sectionsError, setSectionsError] = useState(null);
    const [showSectionsBlock, setShowSectionsBlock] = useState(false);
    const [sectionDraft, setSectionDraft] = useState({ title: "", description: "" });
    const [sectionEditDraft, setSectionEditDraft] = useState(null);

    const industriesPreview = useMemo(() => industries.slice(0, 8), [industries]);
    const docsPreview = useMemo(() => docs.slice(0, 8), [docs]);
    const rolesPreview = useMemo(() => roles.slice(0, 8), [roles]);
    const eventsPreview = useMemo(() => events.slice(0, 8), [events]);

    const roleFilterOptions = useMemo(() => {
        const groups = Array.from(new Set(roles.map((r) => r.role_group).filter(Boolean))).sort();
        const types = Array.from(new Set(roles.map((r) => r.role_type).filter(Boolean))).sort();
        const statuses = Array.from(new Set(roles.map((r) => r.status).filter(Boolean))).sort();
        const companies = Array.from(new Set(roles.map((r) => r.affiliate_company_name || r.organization).filter(Boolean))).sort();
        return { groups, types, statuses, companies };
    }, [roles]);

    const roleKpis = useMemo(() => {
        const total = roles.length;
        const active = roles.filter((r) => (r.status || "activo") === "activo").length;
        const board = roles.filter((r) => Number(r.is_board_member || 0) === 1).length;
        const withCompany = roles.filter((r) => r.affiliate_company_id || r.affiliate_company_name).length;
        const withContact = roles.filter((r) => r.contact_id || r.contact_full_name).length;
        const withAssets = roles.filter((r) => Number(r.assets_count || roleAssetsSummary?.[String(r.id)]?.total || 0) > 0).length;
        const noPeriod = roles.filter((r) => !r.period_start && !r.period_end).length;
        return { total, active, board, withCompany, withContact, withAssets, noPeriod };
    }, [roles, roleAssetsSummary]);

    function roleSortValue(row, key) {
        if (key === "company") return row.affiliate_company_name || row.organization || "";
        if (key === "contact") return row.contact_full_name || row.person_name || "";
        if (key === "period") return row.period_start || row.period_end || "";
        if (key === "assets") return Number(row.assets_count || roleAssetsSummary?.[String(row.id)]?.total || 0);
        if (key === "board") return Number(row.is_board_member || 0);
        if (key === "sort_order") return Number(row.sort_order || 0);
        return row[key] || "";
    }

    function toggleRoleSort(key) {
        setRoleSort((prev) => {
            if (prev?.key === key) {
                return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
            }
            return { key, direction: "asc" };
        });
    }

    function RoleSortHeader({ label, sortKey }) {
        const active = roleSort?.key === sortKey;
        const icon = active ? (roleSort.direction === "asc" ? "▲" : "▼") : "↕";
        return (
            <button
                type="button"
                onClick={() => toggleRoleSort(sortKey)}
                style={{
                    border: 0,
                    background: "transparent",
                    padding: 0,
                    fontWeight: 700,
                    cursor: "pointer",
                    color: active ? "#1d4ed8" : "inherit",
                }}
                title={`Ordenar por ${label}`}
            >
                {label} <span style={{ color: active ? "#1d4ed8" : "#9ca3af" }}>{icon}</span>
            </button>
        );
    }

    const filteredRoles = useMemo(() => {
        const q = (roleFilters.q || "").toLowerCase().trim();

        const list = roles.filter((r) => {
            if (roleFilters.group && r.role_group !== roleFilters.group) return false;
            if (roleFilters.type && r.role_type !== roleFilters.type) return false;
            if (roleFilters.status && (r.status || "activo") !== roleFilters.status) return false;
            if (roleFilters.company && (r.affiliate_company_name || r.organization || "") !== roleFilters.company) return false;
            if (roleFilters.board && String(Number(r.is_board_member || 0)) !== roleFilters.board) return false;

            if (q) {
                const haystack = [
                    r.role_group, r.role_title, r.role_type, r.committee_area, r.status,
                    r.person_name, r.contact_full_name, r.email, r.phone,
                    r.organization, r.affiliate_company_name, r.notes,
                ].filter(Boolean).join(" ").toLowerCase();

                if (!haystack.includes(q)) return false;
            }

            return true;
        });

        const sorted = [...list];
        const { key, direction } = roleSort || {};

        sorted.sort((a, b) => {
            const av = roleSortValue(a, key);
            const bv = roleSortValue(b, key);

            if (typeof av === "number" || typeof bv === "number") {
                return direction === "asc" ? Number(av) - Number(bv) : Number(bv) - Number(av);
            }

            const result = String(av).localeCompare(String(bv), "es", { numeric: true, sensitivity: "base" });
            return direction === "asc" ? result : -result;
        });

        return sorted;
    }, [roles, roleFilters, roleSort, roleAssetsSummary]);

    const selectedIndustry = useMemo(
        () => (industryIdParam ? industries.find((x) => String(x.id) === String(industryIdParam)) : null),
        [industries, industryIdParam]
    );

    const selectedDoc = useMemo(
        () => (docIdParam ? docs.find((x) => String(x.id) === String(docIdParam)) : null),
        [docs, docIdParam]
    );

    const selectedRole = useMemo(
        () => (roleIdParam ? roles.find((x) => String(x.id) === String(roleIdParam)) : null),
        [roles, roleIdParam]
    );

    const selectedEvent = useMemo(
        () => (eventIdParam ? events.find((x) => String(x.id) === String(eventIdParam)) : null),
        [events, eventIdParam]
    );

    function openEditProfile() {
        setProfileEditDraft({ ...(profile || {}) });
        setModal({ kind: "edit_profile" });
    }

    function setPanel(panelKey) {
        const next = new URLSearchParams(searchParams);
        if (!panelKey) next.delete("panel");
        else next.set("panel", panelKey);

        if (panelKey !== "industries") next.delete("industry_id");
        if (panelKey !== "documents") next.delete("doc_id");
        if (panelKey !== "structure") next.delete("role_id");
        if (panelKey !== "events") next.delete("event_id");

        setSearchParams(next, { replace: true });
    }

    function clearSelection(key) {
        const next = new URLSearchParams(searchParams);
        next.delete(key);
        setSearchParams(next, { replace: true });
    }

    function gotoIndustry(id) {
        const next = new URLSearchParams(searchParams);
        next.set("panel", "industries");
        next.set("industry_id", String(id));
        next.delete("doc_id");
        next.delete("role_id");
        next.delete("event_id");
        setSearchParams(next, { replace: true });
    }

    function gotoDoc(id) {
        const next = new URLSearchParams(searchParams);
        next.set("panel", "documents");
        next.set("doc_id", String(id));
        next.delete("industry_id");
        next.delete("role_id");
        next.delete("event_id");
        setSearchParams(next, { replace: true });
    }

    function gotoRole(id) {
        const next = new URLSearchParams(searchParams);
        next.set("panel", "structure");
        next.set("role_id", String(id));
        next.delete("industry_id");
        next.delete("doc_id");
        next.delete("event_id");
        setSearchParams(next, { replace: true });
    }

    function gotoEvent(id) {
        const next = new URLSearchParams(searchParams);
        next.set("panel", "events");
        next.set("event_id", String(id));
        next.delete("industry_id");
        next.delete("doc_id");
        next.delete("role_id");
        setSearchParams(next, { replace: true });
    }

    async function loadInstitutionCore() {
        const data = await safeJsonFetch(`${API_BASE}/institution_get.php`, { headers: authHeaders() });
        if (!data.ok) throw new Error(data.error || "Error cargando institución");
        setProfile(data.profile);
        setDocs(data.documents || []);
    }

    async function loadInstitutionRoles() {
        const data = await safeJsonFetch(`${API_BASE}/institution_roles_list.php`, { headers: authHeaders() });
        if (!data.ok && !data.success) throw new Error(data.error || "Error cargando estructura");
        setRoles(data.roles || data.rows || data.items || []);
    }

    async function loadAffiliatedCompanies() {
        const data = await safeJsonFetch(`${API_BASE}/institution_affiliated_companies_list.php`, { headers: authHeaders() });
        if (!data.ok && !data.success) throw new Error(data.error || "Error cargando empresas afiliadas");
        setAffiliatedCompanies(data.companies || data.rows || data.items || []);
    }

    async function loadCompanyContactsForRole(companyId) {
        if (!companyId) {
            setRoleCompanyContacts([]);
            return [];
        }

        setRoleCompanyContactsLoading(true);
        try {
            const data = await safeJsonFetch(`${API_BASE}/institution_company_contacts_list.php?company_id=${companyId}`, { headers: authHeaders() });
            if (!data.ok && !data.success) throw new Error(data.error || "Error cargando contactos vinculados");
            const list = data.contacts || data.rows || data.items || [];
            setRoleCompanyContacts(list);
            return list;
        } finally {
            setRoleCompanyContactsLoading(false);
        }
    }

    function institutionHumanDate(value) {
        const clean = String(value || "").trim();
        if (!clean || clean === "0000-00-00" || clean === "0000-00-00 00:00:00") return "Sin fecha";
        const iso = clean.slice(0, 10);
        const parts = iso.split("-");
        if (parts.length === 3 && parts[0].length === 4) {
            const meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
            const y = parts[0];
            const m = meses[Math.max(0, Math.min(11, Number(parts[1]) - 1))] || parts[1];
            const d = parts[2];
            return `${d}-${m}-${y}`;
        }
        return clean;
    }

    function institutionPeriodLabel(start, end) {
        const a = institutionHumanDate(start);
        const b = institutionHumanDate(end);
        if (a === "Sin fecha" && b === "Sin fecha") return "Sin periodo";
        if (a !== "Sin fecha" && b === "Sin fecha") return `${a} / Vigente`;
        if (a === "Sin fecha" && b !== "Sin fecha") return `Sin inicio / ${b}`;
        return `${a} / ${b}`;
    }

    function eventTypeLabel(value) {
        const clean = String(value || "").trim();
        if (!clean || clean === "0000-00-00") return "Sin tipo";
        return clean;
    }

    function docTypeLabel(value) {
        const clean = String(value || "").trim();
        if (!clean) return "Documento";
        const map = { file: "Archivo", url: "Liga", link: "Liga", pdf: "PDF" };
        return map[clean] || clean;
    }

    function docFileLabel(d) {
        return d?.file_name || d?.original_name || d?.title || "Abrir";
    }

    function displayCompanyOption(c) {
        const status = c.status ? ` · ${c.status}` : "";
        const city = c.city ? ` · ${c.city}` : "";
        return `${c.name || "Empresa sin nombre"}${city}${status}`;
    }

    function displayLinkedContactOption(c) {
        const name = c.display_name || c.full_name || [c.first_name, c.last_name].filter(Boolean).join(" ").trim() || "Contacto sin nombre";
        const role = c.role_type ? ` · ${c.role_type}` : "";
        const position = c.position_title || c.position ? ` · ${c.position_title || c.position}` : "";
        return `${name}${position}${role}`;
    }

    function applyCompanyToRoleDraft(draft, companyId) {
        const company = affiliatedCompanies.find((x) => String(x.id) === String(companyId));
        return {
            ...draft,
            affiliate_company_id: companyId || "",
            contact_id: "",
            organization: company?.name || draft.organization || "",
        };
    }

    function applyContactToRoleDraft(draft, contactId) {
        const contact = roleCompanyContacts.find((x) => String(x.contact_id) === String(contactId));
        if (!contact) return { ...draft, contact_id: contactId || "" };

        const name = contact.display_name || contact.full_name || [contact.first_name, contact.last_name].filter(Boolean).join(" ").trim();

        return {
            ...draft,
            contact_id: contactId || "",
            person_name: name || draft.person_name || "",
            email: contact.email || draft.email || "",
            phone: contact.mobile || contact.phone || draft.phone || "",
        };
    }

    async function loadIndustries() {
        const data = await safeJsonFetch(`${API_BASE}/industries_list.php`, { headers: authHeaders() });

        // Compatibilidad C2.1.4:
        // industries_list.php puede responder como array directo o como objeto { ok, industries }.
        const list = Array.isArray(data)
            ? data
            : (data?.industries || data?.items || data?.rows || []);

        if (!Array.isArray(data) && data?.ok === false) {
            throw new Error(data.error || "Error cargando industrias");
        }

        setIndustries(list);
        return list;
    }

    async function loadIndustrySectionCounts(indsParam) {
        try {
            const data = await safeJsonFetch(`${API_BASE}/industry_sections_counts.php`, { headers: authHeaders() });
            if (data.ok && data.counts) {
                setIndustrySectionCounts(data.counts);
                return;
            }
        } catch { }

        const counts = {};
        const list = Array.isArray(indsParam) ? indsParam : industries;
        for (const ind of list) {
            try {
                const res = await fetch(`${API_BASE}/industry_sections_list.php?industry_id=${ind.id}`, { headers: authHeaders() });
                const t = await res.text();
                const arr = t ? JSON.parse(t) : [];
                counts[String(ind.id)] = Array.isArray(arr) ? arr.length : 0;
            } catch {
                counts[String(ind.id)] = 0;
            }
        }
        setIndustrySectionCounts(counts);
    }

    async function loadIndustrySections(industryId) {
        if (!industryId) {
            setIndustrySections([]);
            return [];
        }

        setSectionsLoading(true);
        setSectionsError(null);

        try {
            const res = await fetch(`${API_BASE}/industry_sections_list.php?industry_id=${industryId}`, {
                headers: authHeaders(),
            });

            const text = await res.text();
            let data = [];

            try {
                data = text ? JSON.parse(text) : [];
            } catch {
                throw new Error("Respuesta no-JSON en industry_sections_list.php");
            }

            if (data && (data.ok === false || data.success === false)) {
                throw new Error(data.error || "Error al listar sectores");
            }

            const rawList = Array.isArray(data)
                ? data
                : (data.sections || data.items || data.rows || []);

            const list = rawList.map((s) => ({
                ...s,
                title: s.title || s.name || s.sector_name || "Sector sin nombre",
                description: s.description || s.notes || "",
            }));

            setIndustrySections(list);
            return list;
        } catch (e) {
            setIndustrySections([]);
            setSectionsError(e.message);
            return [];
        } finally {
            setSectionsLoading(false);
        }
    }

    async function createIndustrySection(industryId, payload) {
        const data = await safeJsonFetch(`${API_BASE}/industry_section_create.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({
                industry_id: industryId,
                title: payload.title || "",
                description: payload.description || "",
            }),
        });
        if (data.ok === false || data.success === false) throw new Error(data.error || "No se pudo crear sector");
        return data.section || null;
    }

    async function updateIndustrySection(payload) {
        const data = await safeJsonFetch(`${API_BASE}/industry_section_update.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({
                id: payload.id,
                title: payload.title || "",
                description: payload.description || "",
            }),
        });
        if (data.ok === false || data.success === false) throw new Error(data.error || "No se pudo actualizar sector");
    }

    async function deleteIndustrySection(id) {
        const data = await safeJsonFetch(`${API_BASE}/industry_section_delete.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({ id }),
        });
        if (data.ok === false || data.success === false) throw new Error(data.error || "No se pudo eliminar sector");
    }

    async function loadRoleAssetsSummary() {
        try {
            const data = await safeJsonFetch(`${API_BASE}/institution_role_assets_summary.php`, { headers: authHeaders() });
            if (data.ok && data.summary) setRoleAssetsSummary(data.summary);
        } catch {
            setRoleAssetsSummary({});
        }
    }

    async function loadRoleAssets(roleId) {
        setRoleAssetsLoading(true);
        try {
            const data = await safeJsonFetch(`${API_BASE}/institution_role_assets_list.php?role_id=${roleId}`, { headers: authHeaders() });
            if (!data.ok) throw new Error(data.error || "Error al listar archivos");
            setRoleAssets(data.assets || []);
        } finally {
            setRoleAssetsLoading(false);
        }
    }

    async function uploadRoleAssets(roleId) {
        if (!roleId) throw new Error("role_id inválido");
        if (!roleAssetFiles.length) throw new Error("Selecciona archivos");
        for (const file of roleAssetFiles) {
            const form = new FormData();
            form.append("role_id", String(roleId));
            form.append("title", roleAssetTitle || "");
            form.append("sort_order", "0");
            form.append("file", file);

            const data = await safeJsonFetch(`${API_BASE}/institution_role_asset_upload.php`, {
                method: "POST",
                headers: authHeaders(),
                body: form,
            });
            if (!data.ok) throw new Error(data.error || "No se pudo subir archivo");
        }
        setRoleAssetFiles([]);
        setRoleAssetTitle("");
        await loadRoleAssets(roleId);
        await loadRoleAssetsSummary();
    }

    async function deleteRoleAsset(assetId, roleId) {
        const data = await safeJsonFetch(`${API_BASE}/institution_role_asset_delete.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({ id: assetId, deleteFile: 1 }),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo eliminar archivo");
        await loadRoleAssets(roleId);
        await loadRoleAssetsSummary();
    }

    async function loadEvents() {
        const data = await safeJsonFetch(`${API_BASE}/institution_events_list.php`, { headers: authHeaders() });
        if (!data.ok) throw new Error(data.error || "Error cargando eventos");
        setEvents(data.events || []);
    }

    async function loadAll() {
        setLoading(true);
        try {
            await loadInstitutionCore();
            await loadInstitutionRoles();
            await loadAffiliatedCompanies();
            const inds = await loadIndustries();
            await loadIndustrySectionCounts(inds);
            await loadRoleAssetsSummary();
            await loadEvents();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { loadAll(); }, []);

    useEffect(() => {
        if (panelParam !== "events") return;
        if (!selectedEvent?.id) {
            setEventPhotos([]);
            return;
        }
        loadEventPhotos(selectedEvent.id).catch((e) => setToast({ type: "error", msg: e.message }));
    }, [panelParam, selectedEvent?.id]);

    useEffect(() => {
        if (panelParam !== "structure") return;
        if (!selectedRole?.id) {
            setRoleAssets([]);
            return;
        }
        loadRoleAssets(selectedRole.id).catch((e) => setToast({ type: "error", msg: e.message }));
    }, [panelParam, selectedRole?.id]);

    async function apiCreateIndustry(payload) {
        const data = await safeJsonFetch(`${API_BASE}/industry_create.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo crear");
        await loadIndustries();
    }

    async function apiUpdateIndustry(payload) {
        const data = await safeJsonFetch(`${API_BASE}/industry_update.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo actualizar");
        await loadIndustries();
    }

    async function apiDeleteIndustry(id) {
        const data = await safeJsonFetch(`${API_BASE}/industry_delete.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({ id }),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo eliminar");
        await loadIndustries();
    }

    async function apiUploadDoc() {
        if (!docDraft.title?.trim()) throw new Error("Falta el título");
        if (!docFile) throw new Error("Selecciona un archivo");

        const form = new FormData();
        form.append("category", docDraft.category || "Otros");
        form.append("title", docDraft.title || "");
        form.append("description", docDraft.description || "");
        form.append("sort_order", String(docDraft.sort_order || 0));
        form.append("uploaded_by", localStorage.getItem("displayName") || "");
        form.append("file", docFile);

        const data = await safeJsonFetch(`${API_BASE}/institution_document_upload.php`, {
            method: "POST",
            headers: authHeaders(),
            body: form,
        });
        if (!data.ok) throw new Error(data.error || "No se pudo subir");

        setDocDraft({ category: "Otros", title: "", description: "", sort_order: 0 });
        setDocFile(null);
        await loadInstitutionCore();
    }

    async function apiDeleteDoc(id) {
        const data = await safeJsonFetch(`${API_BASE}/institution_document_delete.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({ id, deleteFile: 1 }),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo eliminar");
        await loadInstitutionCore();
    }

    async function apiCreateRole(payload) {
        const data = await safeJsonFetch(`${API_BASE}/institution_role_create.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });
        if (!data.ok && !data.success) throw new Error(data.error || "No se pudo crear rol");
        await loadInstitutionRoles();
        return data;
    }

    async function apiUpdateRole(payload) {
        const data = await safeJsonFetch(`${API_BASE}/institution_role_update.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });
        if (!data.ok && !data.success) throw new Error(data.error || "No se pudo actualizar rol");
        await loadInstitutionRoles();
    }

    async function apiDeleteRole(id) {
        const data = await safeJsonFetch(`${API_BASE}/institution_role_delete.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({ id }),
        });
        if (!data.ok && !data.success) throw new Error(data.error || "No se pudo eliminar rol");
        await loadInstitutionRoles();
    }

    async function apiUploadRolePlan(roleId, file) {
        const form = new FormData();
        form.append("role_id", String(roleId));
        form.append("file", file);

        const data = await safeJsonFetch(`${API_BASE}/institution_role_plan_upload.php`, {
            method: "POST",
            headers: authHeaders(),
            body: form,
        });
        if (!data.ok) throw new Error(data.error || "No se pudo subir documento del plan");
        return data.file_path;
    }

    async function apiUploadRoleCertificate(roleId, file) {
        const form = new FormData();
        form.append("role_id", String(roleId));
        form.append("file", file);

        const data = await safeJsonFetch(`${API_BASE}/institution_role_certificate_upload.php`, {
            method: "POST",
            headers: authHeaders(),
            body: form,
        });
        if (!data.ok) throw new Error(data.error || "No se pudo subir imagen del certificado");
        return data.file_path;
    }

    async function apiCreateEvent(payload) {
        const data = await safeJsonFetch(`${API_BASE}/institution_event_create.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo crear evento");
        await loadEvents();
    }

    async function apiUpdateProfile(payload) {
        const data = await safeJsonFetch(`${API_BASE}/institution_update.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo guardar perfil");
        await loadInstitutionCore();
    }

    async function apiUpdateEvent(payload) {
        const data = await safeJsonFetch(`${API_BASE}/institution_event_update.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo actualizar evento");
        await loadEvents();
    }

    async function apiDeleteEvent(id) {
        const data = await safeJsonFetch(`${API_BASE}/institution_event_delete.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({ id }),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo eliminar evento");
        await loadEvents();
    }

    async function loadEventPhotos(eventId) {
        const data = await safeJsonFetch(`${API_BASE}/institution_event_photos_list.php?event_id=${eventId}`, { headers: authHeaders() });
        if (!data.ok) throw new Error(data.error || "No se pudieron cargar fotos");
        setEventPhotos(data.photos || []);
    }

    async function apiUploadEventPhotos(eventId) {
        if (!eventId) throw new Error("Selecciona un evento");
        if (!eventPhotoFiles.length) throw new Error("Selecciona imágenes");

        for (const file of eventPhotoFiles) {
            const form = new FormData();
            form.append("event_id", String(eventId));
            form.append("caption", eventPhotoCaption || "");
            form.append("photo_type", eventPhotoType || "general");
            form.append("sort_order", "0");
            form.append("file", file);

            const data = await safeJsonFetch(`${API_BASE}/institution_event_photo_upload.php`, {
                method: "POST",
                headers: authHeaders(),
                body: form,
            });
            if (!data.ok) throw new Error(data.error || `No se pudo subir ${file.name}`);
        }

        setEventPhotoFiles([]);
        setEventPhotoCaption("");
        setEventPhotoType("general");
        await loadEventPhotos(eventId);
    }

    async function apiDeleteEventPhoto(photoId) {
        const data = await safeJsonFetch(`${API_BASE}/institution_event_photo_delete.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify({ id: photoId, deleteFile: 1 }),
        });
        if (!data.ok) throw new Error(data.error || "No se pudo eliminar foto");
        if (selectedEvent?.id) await loadEventPhotos(selectedEvent.id);
    }

    function openNewIndustry() {
        setIndustryDraft({ name: "", description: "" });
        setModal({ kind: "new_industry" });
    }

    function openEditIndustry(ind, openSections = true) {
        setIndustryEditDraft({ ...ind });
        // C2.1.4D: al entrar al modal de eje / industria, los sectores siempre quedan visibles.
        setShowSectionsBlock(true);
        setSectionDraft({ title: "", description: "" });
        setSectionEditDraft(null);
        setModal({ kind: "edit_industry" });
        loadIndustrySections(ind.id);
    }

    function openNewDoc() {
        setDocDraft({ category: "Otros", title: "", description: "" });
        setDocFile(null);
        setModal({ kind: "new_doc" });
    }

    function openNewRole() {
        setRoleDraft({ ...blankRoleDraft });
        setRoleCompanyContacts([]);
        setRolePlanFile(null);
        setRoleCertFile(null);
        setModal({ kind: "new_role" });
    }

    function openEditRole(role) {
        const next = {
            ...blankRoleDraft,
            ...role,
            affiliate_company_id: role.affiliate_company_id ? String(role.affiliate_company_id) : "",
            contact_id: role.contact_id ? String(role.contact_id) : "",
            is_board_member: Number(role.is_board_member || 0),
            period_start: role.period_start ? String(role.period_start).slice(0, 10) : "",
            period_end: role.period_end ? String(role.period_end).slice(0, 10) : "",
            status: role.status || "activo",
            role_type: role.role_type || "representante",
        };
        setRoleEditDraft(next);
        setRoleCompanyContacts([]);
        if (next.affiliate_company_id) {
            loadCompanyContactsForRole(next.affiliate_company_id).catch((e) => setToast({ type: "error", msg: e.message }));
        }
        setRolePlanFile(null);
        setRoleCertFile(null);
        setModal({ kind: "edit_role" });
    }

    function renderRoleProFields(draft, setDraft, isEdit = false) {
        const selectedCompany = affiliatedCompanies.find((x) => String(x.id) === String(draft?.affiliate_company_id || ""));
        const companyHasNoContacts = draft?.affiliate_company_id && !roleCompanyContactsLoading && roleCompanyContacts.length === 0;

        return (
            <>
                <Field label="Empresa afiliada" full>
                    <select
                        value={draft?.affiliate_company_id ?? ""}
                        onChange={async (e) => {
                            const companyId = e.target.value;
                            const nextDraft = applyCompanyToRoleDraft(draft, companyId);
                            setDraft(nextDraft);
                            await loadCompanyContactsForRole(companyId);
                        }}
                    >
                        <option value="">— Seleccionar empresa afiliada —</option>
                        {affiliatedCompanies.map((c) => (
                            <option key={c.id} value={String(c.id)}>
                                {displayCompanyOption(c)}
                            </option>
                        ))}
                    </select>
                    {selectedCompany ? (
                        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                            {selectedCompany.region || "Sin región"} · {selectedCompany.city || "Sin ciudad"} · Contactos: {selectedCompany.contacts_count ?? 0}
                        </div>
                    ) : (
                        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                            Solo aparecen empresas con estatus de afiliado.
                        </div>
                    )}
                </Field>

                <Field label="Contacto vinculado" full>
                    <select
                        value={draft?.contact_id ?? ""}
                        disabled={!draft?.affiliate_company_id || roleCompanyContactsLoading}
                        onChange={(e) => {
                            const contactId = e.target.value;
                            setDraft(applyContactToRoleDraft(draft, contactId));
                        }}
                    >
                        <option value="">
                            {roleCompanyContactsLoading ? "Cargando contactos..." : "— Seleccionar contacto vinculado —"}
                        </option>
                        {roleCompanyContacts.map((c) => (
                            <option key={c.link_id || c.contact_id} value={String(c.contact_id)}>
                                {displayLinkedContactOption(c)}
                            </option>
                        ))}
                    </select>
                    {companyHasNoContacts ? (
                        <div className="alert-info" style={{ marginTop: 8 }}>
                            Esta empresa afiliada aún no tiene contactos vinculados. Vincula contactos desde la Ficha 360 de Afiliaciones.
                        </div>
                    ) : null}
                </Field>

                <Field label="Grupo">
                    <select value={draft?.role_group ?? "Otro"} onChange={(e) => setDraft({ ...draft, role_group: e.target.value })}>
                        {ROLE_GROUPS.map((g) => <option key={g} value={g}>{g}</option>)}
                    </select>
                </Field>

                <Field label="Tipo de rol">
                    <select value={draft?.role_type ?? "representante"} onChange={(e) => setDraft({ ...draft, role_type: e.target.value })}>
                        {INSTITUTION_ROLE_TYPES.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                    </select>
                </Field>

                <Field label="Rol institucional" full>
                    <input value={draft?.role_title ?? ""} onChange={(e) => setDraft({ ...draft, role_title: e.target.value })} placeholder="Ej. Representante ante el CLIP / Presidente / Consejero" />
                </Field>

                <Field label="Comité / área">
                    <input value={draft?.committee_area ?? ""} onChange={(e) => setDraft({ ...draft, committee_area: e.target.value })} placeholder="Ej. Afiliaciones, Consejo, Tecnología" />
                </Field>

                <Field label="Estatus">
                    <select value={draft?.status ?? "activo"} onChange={(e) => setDraft({ ...draft, status: e.target.value })}>
                        {INSTITUTION_ROLE_STATUS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                    </select>
                </Field>

                <Field label="Inicio periodo">
                    <input type="date" value={draft?.period_start ?? ""} onChange={(e) => setDraft({ ...draft, period_start: e.target.value })} />
                </Field>

                <Field label="Fin periodo">
                    <input type="date" value={draft?.period_end ?? ""} onChange={(e) => setDraft({ ...draft, period_end: e.target.value })} />
                </Field>

                <Field label="Nombre">
                    <input value={draft?.person_name ?? ""} onChange={(e) => setDraft({ ...draft, person_name: e.target.value })} />
                </Field>

                <Field label="Email">
                    <input value={draft?.email ?? ""} onChange={(e) => setDraft({ ...draft, email: e.target.value })} />
                </Field>

                <Field label="Móvil">
                    <input value={draft?.phone ?? ""} onChange={(e) => setDraft({ ...draft, phone: e.target.value })} />
                </Field>

                <Field label="Orden">
                    <input type="number" value={draft?.sort_order ?? 0} onChange={(e) => setDraft({ ...draft, sort_order: Number(e.target.value || 0) })} />
                </Field>

                <Field label="Organización" full>
                    <input value={draft?.organization ?? ""} onChange={(e) => setDraft({ ...draft, organization: e.target.value })} />
                </Field>

                <Field label="Miembro de consejo">
                    <select value={String(Number(draft?.is_board_member || 0))} onChange={(e) => setDraft({ ...draft, is_board_member: Number(e.target.value) })}>
                        <option value="0">No</option>
                        <option value="1">Sí</option>
                    </select>
                </Field>

                <Field label="Notas" full>
                    <textarea rows={2} value={draft?.notes ?? ""} onChange={(e) => setDraft({ ...draft, notes: e.target.value })} />
                </Field>
            </>
        );
    }

    function openNewEvent() {
        const blank = {
            id: null,
            event_date: fmtDateISO(new Date()),
            title: "",
            event_type: EVENT_TYPES[0],
            description: "",
            reason: "",
            summary_text: "",
            location: "",
            tags: "",
            facebook_post_url: "",
            instagram_post_url: "",
            is_active: 1,
        };
        setEventEditDraft(blank);
        setModal({ kind: "new_event" });
    }

    function openEditEvent(ev) {
        setEventEditDraft({
            id: ev.id,
            event_date: fmtDateISO(ev.event_date),
            title: ev.title || "",
            event_type: ev.event_type || EVENT_TYPES[0],
            description: ev.description || "",
            reason: ev.reason || "",
            summary_text: ev.summary_text || "",
            location: ev.location || "",
            tags: ev.tags || "",
            facebook_post_url: ev.facebook_post_url || "",
            instagram_post_url: ev.instagram_post_url || "",
            is_active: Number(ev.is_active ?? 1),
        });
        setModal({ kind: "edit_event" });
    }

    function genSummaryIntoEventEditDraft() {
        const base = eventEditDraft;
        const summary = buildEventSummary({
            date: base.event_date,
            title: base.title,
            location: base.location,
            reason: base.reason,
            tags: base.tags,
        });
        setEventEditDraft({ ...base, summary_text: summary });
    }

    if (loading) {
        return (
            <MainLayout>
                <GridRowsProStyle />
                <OrbisInstitutionUXStyle />
                <div className="institution-orbis-pro page-container grid-rows-pro">Cargando Institución…</div>
            </MainLayout>
        );
    }

    if (!profile) {
        return (
            <MainLayout>
                <GridRowsProStyle />
                <OrbisInstitutionUXStyle />
                <div className="institution-orbis-pro page-container grid-rows-pro">No se pudo cargar el perfil institucional.</div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <GridRowsProStyle />
            <OrbisInstitutionUXStyle />
            <div className="institution-orbis-pro page-container grid-rows-pro">
                <div className="page-header">
                    <div>
                        <h1 className="page-title">CLIP - Consejo Lagunero de la Iniciativa Privada.</h1>
                        <p className="page-subtitle">Tablero + listados (Acciones por renglón) + Detalles por registro.</p>
                    </div>
                    <div className="page-header-actions">
                        <button className="btn btn-secondary" onClick={loadAll}>Recargar</button>
                    </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: "1rem" }}>
                    <div className="card">
                        <div className="card-header-inline">
                            <div>
                                <div style={{ fontSize: 12, color: "#666", fontWeight: 600 }}>Ejes / Industrias</div>
                                <div style={{ fontSize: "1.6rem", fontWeight: 700 }}>{industries.length}</div>
                            </div>
                            <span className="badge">Ejes</span>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header-inline">
                            <div>
                                <div style={{ fontSize: 12, color: "#666", fontWeight: 600 }}>Documentos</div>
                                <div style={{ fontSize: "1.6rem", fontWeight: 700 }}>{docs.length}</div>
                            </div>
                            <span className="badge">Docs</span>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header-inline">
                            <div>
                                <div style={{ fontSize: 12, color: "#666", fontWeight: 600 }}>Estructura</div>
                                <div style={{ fontSize: "1.6rem", fontWeight: 700 }}>{roles.length}</div>
                            </div>
                            <span className="badge">Roles</span>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header-inline">
                            <div>
                                <div style={{ fontSize: 12, color: "#666", fontWeight: 600 }}>Eventos</div>
                                <div style={{ fontSize: "1.6rem", fontWeight: 700 }}>{events.length}</div>
                            </div>
                            <span className="badge">Eventos</span>
                        </div>
                    </div>

                    <div className="card" style={{ marginTop: "1rem", gridColumn: "1 / -1" }}>
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>
                                Perfil institucional
                            </h3>
                            <div className="form-actions">
                                <button className="btn btn-primary" onClick={openEditProfile}>
                                    Editar perfil
                                </button>
                            </div>
                        </div>

                        <div className="form-grid">
                            <div className="form-field full-width">
                                <label>Descripción / Tagline</label>
                                <div style={{ color: "#d7e8f6", lineHeight: 1.65 }}>
                                    {profile?.tagline ? profile.tagline : <span style={{ color: "#9fc4df" }}>—</span>}
                                </div>
                            </div>

                            <div className="form-field full-width">
                                <label>Misión</label>
                                <div style={{ color: "#d7e8f6", lineHeight: 1.65, whiteSpace: "pre-wrap" }}>
                                    {profile?.mission ? profile.mission : <span style={{ color: "#9fc4df" }}>—</span>}
                                </div>
                            </div>

                            <div className="form-field full-width">
                                <label>Visión</label>
                                <div style={{ color: "#d7e8f6", lineHeight: 1.65, whiteSpace: "pre-wrap" }}>
                                    {profile?.vision ? profile.vision : <span style={{ color: "#9fc4df" }}>—</span>}
                                </div>
                            </div>

                            <div className="form-field full-width">
                                <label>Objetivos</label>
                                <div style={{ color: "#d7e8f6", lineHeight: 1.65, whiteSpace: "pre-wrap" }}>
                                    {profile?.objectives ? profile.objectives : <span style={{ color: "#9fc4df" }}>—</span>}
                                </div>
                            </div>

                            <div className="form-field full-width">
                                <label>Razones</label>
                                <div style={{ color: "#d7e8f6", lineHeight: 1.65, whiteSpace: "pre-wrap" }}>
                                    {profile?.razones ? profile.razones : <span style={{ color: "#9fc4df" }}>—</span>}
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Sitio web</label>
                                <div style={{ color: "#d7e8f6" }}>
                                    {profile?.website ? (
                                        <a className="link-button" href={profile.website} target="_blank" rel="noreferrer">
                                            {profile.website}
                                        </a>
                                    ) : (
                                        <span style={{ color: "#9fc4df" }}>—</span>
                                    )}
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Correo</label>
                                <div style={{ color: "#d7e8f6" }}>
                                    {profile?.email ? profile.email : <span style={{ color: "#9fc4df" }}>—</span>}
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Teléfono</label>
                                <div style={{ color: "#d7e8f6" }}>
                                    {profile?.phone ? profile.phone : <span style={{ color: "#9fc4df" }}>—</span>}
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Redes</label>
                                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                                    {profile?.social_facebook ? (
                                        <a className="link-button" href={profile.social_facebook} target="_blank" rel="noreferrer">Facebook</a>
                                    ) : null}
                                    {profile?.social_instagram ? (
                                        <a className="link-button" href={profile.social_instagram} target="_blank" rel="noreferrer">Instagram</a>
                                    ) : null}
                                    {profile?.social_linkedin ? (
                                        <a className="link-button" href={profile.social_linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
                                    ) : null}
                                    {profile?.social_x ? (
                                        <a className="link-button" href={profile.social_x} target="_blank" rel="noreferrer">X</a>
                                    ) : null}
                                    {profile?.social_youtube ? (
                                        <a className="link-button" href={profile.social_youtube} target="_blank" rel="noreferrer">YouTube</a>
                                    ) : null}

                                    {!profile?.social_facebook && !profile?.social_instagram && !profile?.social_linkedin && !profile?.social_x && !profile?.social_youtube ? (
                                        <span style={{ color: "#9fc4df" }}>—</span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: "1rem", display: "grid", gap: "1rem" }}>
                    <div className="card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>Ejes / Industrias</h3>
                            <div className="form-actions">
                                <button className="btn btn-primary" onClick={openNewIndustry}>Nuevo eje</button>
                                <button className="btn btn-secondary" onClick={() => setPanel("industries")}>Ver lista</button>
                            </div>
                        </div>
                        {industriesPreview.length === 0 ? (
                            <div className="alert-info">Aún no hay ejes registrados.</div>
                        ) : (
                            <div className="table-wrapper">
                                <table className="table">
                                    <thead><tr><th>Nombre</th><th>Descripción</th><th>PIB</th><th>Notas</th><th>Secciones</th><th style={{ width: 160 }}>Acciones</th></tr></thead>
                                    <tbody>
                                        {industriesPreview.map((i) => (
                                            <tr key={i.id}>
                                                <td><strong>{i.name}</strong></td>
                                                <td style={{ color: "#9fc4df", fontSize: 12 }}>{i.description || "—"}</td>
                                                <td style={{ color: "#9fc4df", fontSize: 12 }}>{i.pib || "—"}</td>
                                                <td style={{ color: "#9fc4df", fontSize: 12 }}>{i.notes || "—"}</td>
                                                <td style={{ color: "#111827", fontSize: 12 }}>{industrySectionCounts[String(i.id)] ?? 0}</td>
                                                <td>
                                                    <div className="form-actions">
                                                        <button className="btn btn-secondary btn-small" onClick={() => openEditIndustry(i, true)}>Detalles</button>
                                                        <button className="btn btn-secondary btn-small" onClick={() => openEditIndustry(i, true)}>Sectores</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className="card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>Estructura</h3>
                            <div className="form-actions">
                                <button className="btn btn-primary" onClick={openNewRole}>Nuevo rol</button>
                                <button className="btn btn-secondary" onClick={() => setPanel("structure")}>Ver lista</button>
                            </div>
                        </div>
                        {rolesPreview.length === 0 ? (
                            <div className="alert-info">Aún no hay roles.</div>
                        ) : (
                            <div className="table-wrapper">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Grupo</th>
                                            <th>Rol</th>
                                            <th>Empresa / contacto</th>
                                            <th>Nombre</th>
                                            <th>Periodo</th>
                                            <th style={{ width: 140 }}>Archivos</th>
                                            <th style={{ width: 160 }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rolesPreview.map((r) => (
                                            <tr key={r.id}>
                                                <td style={{ color: "#9fc4df", fontSize: 12 }}>{r.role_group || "—"}</td>
                                                <td><strong>{r.role_title}</strong></td>
                                                <td style={{ fontSize: 12, color: "#9fc4df" }}>
                                                    <div>{r.affiliate_company_name || r.organization || "—"}</div>
                                                    <div>{r.contact_full_name || r.person_name || "—"}</div>
                                                </td>
                                                <td>{r.person_name || "—"}</td>
                                                <td style={{ fontSize: 12, color: "#9fc4df" }}>{institutionPeriodLabel(r.period_start, r.period_end)}</td>
                                                <td>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                        {roleAssetsSummary?.[String(r.id)]?.first_image_path ? (
                                                            <img
                                                                src={roleAssetsSummary[String(r.id)].first_image_path}
                                                                alt="img"
                                                                style={{ width: 34, height: 34, objectFit: "cover", borderRadius: 6, border: "1px solid #e5e7eb" }}
                                                            />
                                                        ) : (
                                                            <div style={{ width: 34, height: 34, borderRadius: 6, border: "1px solid #e5e7eb", display: "grid", placeItems: "center", color: "#9ca3af" }}>—</div>
                                                        )}
                                                        <div style={{ fontSize: 12, color: "#d7e8f6" }}>
                                                            {(roleAssetsSummary?.[String(r.id)]?.total ?? 0)}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="form-actions">
                                                        <button className="btn btn-secondary btn-small" onClick={() => gotoRole(r.id)}>Detalles</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className="card institution-wide-card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>Documentos institucionales</h3>
                            <div className="form-actions">
                                <button className="btn btn-primary" onClick={openNewDoc}>Nuevo documento</button>
                                <button className="btn btn-secondary" onClick={() => setPanel("documents")}>Ver lista</button>
                            </div>
                        </div>
                        {docsPreview.length === 0 ? (
                            <div className="alert-info">Aún no hay documentos.</div>
                        ) : (
                            <div className="table-wrapper">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Documento</th>
                                            <th>Categoría</th>
                                            <th>Tipo</th>
                                            <th>Archivo / Liga</th>
                                            <th>Fecha</th>
                                            <th style={{ width: 240 }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {docsPreview.map((d) => (
                                            <tr key={d.id}>
                                                <td><strong>{fileIconByMime(d.mime_type)} {d.title || d.original_name || "Documento"}</strong></td>
                                                <td style={{ color: "#9fc4df", fontSize: 12 }}>{d.category || d.document_category || "General"}</td>
                                                <td>{docTypeLabel(d.doc_type || d.type)}</td>
                                                <td>
                                                    {(d.file_url || d.file_path || d.url) ? (
                                                        <a
                                                            className="institution-link-strong"
                                                            href={d.file_url || d.file_path || d.url}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {docFileLabel(d)}
                                                        </a>
                                                    ) : "—"}
                                                </td>
                                                <td>{institutionHumanDate(d.uploaded_at || d.created_at)}</td>
                                                <td>
                                                    <div className="institution-actions-row">
                                                        {(d.file_url || d.file_path || d.url) ? (
                                                            <a className="btn btn-secondary btn-small" href={d.file_url || d.file_path || d.url} target="_blank" rel="noreferrer">Abrir</a>
                                                        ) : null}
                                                        <button className="btn btn-secondary btn-small" onClick={() => gotoDoc(d.id)}>Detalles</button>
                                                        <button className="btn btn-secondary btn-small" onClick={() => gotoDoc(d.id)}>Editar</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className="card institution-wide-card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>Eventos institucionales</h3>
                            <div className="form-actions">
                                <button className="btn btn-primary" onClick={openNewEvent}>Nuevo evento</button>
                                <button className="btn btn-secondary" onClick={() => setPanel("events")}>Ver lista</button>
                            </div>
                        </div>
                        {eventsPreview.length === 0 ? (
                            <div className="alert-info">Aún no hay eventos.</div>
                        ) : (
                            <div className="table-wrapper">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Evento</th>
                                            <th>Tipo</th>
                                            <th>Lugar</th>
                                            <th>Estatus</th>
                                            <th style={{ width: 240 }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {eventsPreview.map((ev) => (
                                            <tr key={ev.id}>
                                                <td>{institutionHumanDate(ev.event_date || ev.start_date)}</td>
                                                <td><strong>{ev.title}</strong></td>
                                                <td style={{ color: "#9fc4df", fontSize: 12 }}>{eventTypeLabel(ev.event_type || ev.type)}</td>
                                                <td>{ev.location || "—"}</td>
                                                <td>{ev.status || "Activo"}</td>
                                                <td>
                                                    <div className="institution-actions-row">
                                                        <button className="btn btn-secondary btn-small" onClick={() => gotoEvent(ev.id)}>Detalles</button>
                                                        <button className="btn btn-secondary btn-small" onClick={() => openEditEvent(ev)}>Editar</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>

                <Drawer open={panelParam === "structure"} title="Estructura CLIP" subtitle="Consejo, comités, representantes, empresas afiliadas y roles institucionales" onClose={() => setPanel(null)}>
                    <div className="card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>
                                {selectedRole ? "Consulta (rol seleccionado)" : "Consulta (lista completa)"}
                            </h3>

                            <div className="form-actions">
                                {selectedRole ? (
                                    <>
                                        <button className="btn btn-secondary" onClick={() => clearSelection("role_id")}>Ver lista</button>
                                        <button className="btn btn-primary" onClick={() => openEditRole(selectedRole)}>Editar</button>
                                    </>
                                ) : (
                                    <button className="btn btn-primary" onClick={openNewRole}>Nuevo rol</button>
                                )}
                            </div>
                        </div>

                        {selectedRole ? (
                            <div style={{ display: "grid", gap: 6 }}>
                                <div><strong>ID:</strong> {selectedRole.id}</div>
                                <div><strong>Grupo:</strong> {selectedRole.role_group || "—"}</div>
                                <div><strong>Rol:</strong> {selectedRole.role_title || "—"}</div>
                                <div><strong>Nombre:</strong> {selectedRole.person_name || "—"}</div>
                                <div><strong>Email:</strong> {selectedRole.email || "—"}</div>
                                <div><strong>Móvil:</strong> {selectedRole.phone || "—"}</div>
                                <div><strong>Organización:</strong> {selectedRole.affiliate_company_name || selectedRole.organization || "—"}</div>
                                <div><strong>Empresa afiliada:</strong> {selectedRole.affiliate_company_name || "—"}</div>
                                <div><strong>Contacto vinculado:</strong> {selectedRole.contact_full_name || selectedRole.person_name || "—"}</div>
                                <div><strong>Tipo de rol:</strong> {selectedRole.role_type || "—"}</div>
                                <div><strong>Comité / área:</strong> {selectedRole.committee_area || "—"}</div>
                                <div><strong>Periodo:</strong> {institutionPeriodLabel(selectedRole.period_start, selectedRole.period_end)}</div>
                                <div><strong>Estatus:</strong> {selectedRole.status || "—"}</div>
                                <div><strong>Consejo:</strong> {Number(selectedRole.is_board_member || 0) === 1 ? "Sí" : "No"}</div>

                                <div className="card" style={{ marginTop: 10 }}>
                                    <div className="card-header-inline">
                                        <h3 className="card-title" style={{ margin: 0 }}>Archivos del rol</h3>
                                        <span className="badge">{roleAssets?.length ?? 0}</span>
                                    </div>

                                    <div className="form-grid">
                                        <Field label="Título (opcional)" full>
                                            <input value={roleAssetTitle} onChange={(e) => setRoleAssetTitle(e.target.value)} />
                                        </Field>

                                        <Field label="Selecciona archivos" full>
                                            <input
                                                type="file"
                                                multiple
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,image/png,image/jpeg,image/webp"
                                                onChange={(e) => setRoleAssetFiles(Array.from(e.target.files || []))}
                                            />
                                            <div style={{ fontSize: 12, color: "#6b7280" }}>
                                                {roleAssetFiles.length ? `${roleAssetFiles.length} seleccionado(s)` : "—"}
                                            </div>
                                        </Field>

                                        <div className="form-actions full-width">
                                            <button
                                                className="btn btn-primary"
                                                onClick={async () => {
                                                    try {
                                                        await uploadRoleAssets(selectedRole.id);
                                                        setToast({ type: "ok", msg: "Archivos subidos" });
                                                    } catch (e) {
                                                        setToast({ type: "error", msg: e.message });
                                                    }
                                                }}
                                            >
                                                Subir
                                            </button>

                                            <button
                                                className="btn btn-secondary"
                                                onClick={async () => {
                                                    try {
                                                        await loadRoleAssets(selectedRole.id);
                                                        setToast({ type: "ok", msg: "Lista actualizada" });
                                                    } catch (e) {
                                                        setToast({ type: "error", msg: e.message });
                                                    }
                                                }}
                                            >
                                                Actualizar
                                            </button>
                                        </div>
                                    </div>

                                    {roleAssetsLoading ? <div>Cargando archivos…</div> : null}

                                    {roleAssets.length === 0 ? (
                                        <div className="alert-info">Este rol no tiene archivos aún.</div>
                                    ) : (
                                        <div style={{ display: "grid", gap: 10 }}>
                                            {roleAssets.map((a) => (
                                                <div key={a.id} className="card" style={{ padding: 10, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                        {a.is_image ? (
                                                            <img
                                                                src={a.file_path}
                                                                alt={a.title || a.file_name}
                                                                style={{ width: 56, height: 56, objectFit: "cover", borderRadius: 8, border: "1px solid #e5e7eb" }}
                                                            />
                                                        ) : (
                                                            <div style={{ width: 56, height: 56, borderRadius: 8, border: "1px solid #e5e7eb", display: "grid", placeItems: "center", color: "#6b7280" }}>
                                                                {fileIconByMime(a.mime_type)}
                                                            </div>
                                                        )}
                                                        <div>
                                                            <div style={{ fontWeight: 700 }}>
                                                                {a.title || a.file_name}
                                                            </div>
                                                            <div style={{ fontSize: 12, color: "#6b7280" }}>
                                                                {a.mime_type}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-actions">
                                                        <a className="link-button" href={a.file_path} target="_blank" rel="noreferrer">
                                                            Abrir
                                                        </a>
                                                        <button
                                                            className="btn btn-danger btn-small"
                                                            onClick={async () => {
                                                                try {
                                                                    await deleteRoleAsset(a.id, selectedRole.id);
                                                                    setToast({ type: "ok", msg: "Archivo eliminado" });
                                                                } catch (e) {
                                                                    setToast({ type: "error", msg: e.message });
                                                                }
                                                            }}
                                                        >
                                                            Eliminar
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {selectedRole.notes ? <div><strong>Notas:</strong> {selectedRole.notes}</div> : null}

                                <div className="form-actions" style={{ marginTop: 10 }}>
                                    <button
                                        className="btn btn-danger"
                                        onClick={async () => {
                                            try {
                                                await apiDeleteRole(selectedRole.id);
                                                setToast({ type: "ok", msg: "Rol eliminado" });
                                                clearSelection("role_id");
                                            } catch (e) {
                                                setToast({ type: "error", msg: e.message });
                                            }
                                        }}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(130px, 1fr))", gap: 10, marginBottom: 12 }}>
                                    {[
                                        ["Roles", roleKpis.total, "Total"],
                                        ["Activos", roleKpis.active, "Vigentes"],
                                        ["Consejo", roleKpis.board, "Board"],
                                        ["Con empresa", roleKpis.withCompany, "Afiliadas"],
                                        ["Con contacto", roleKpis.withContact, "Vinculados"],
                                        ["Con archivos", roleKpis.withAssets, "Assets"],
                                        ["Sin periodo", roleKpis.noPeriod, "Atención"],
                                    ].map(([label, value, hint]) => (
                                        <div key={label} className="card" style={{ padding: 12, minHeight: 78 }}>
                                            <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 700 }}>{label}</div>
                                            <div style={{ fontSize: 24, fontWeight: 800, color: "#111827", marginTop: 4 }}>{value}</div>
                                            <div style={{ fontSize: 10, color: "#9ca3af" }}>{hint}</div>
                                        </div>
                                    ))}
                                </div>

                                <div className="card" style={{ marginBottom: 12 }}>
                                    <div className="card-header-inline">
                                        <div>
                                            <h3 className="card-title" style={{ margin: 0 }}>Filtros de estructura</h3>
                                            <div style={{ fontSize: 12, color: "#6b7280" }}>
                                                Vista: {filteredRoles.length} de {roles.length} rol(es)
                                            </div>
                                        </div>
                                        <button
                                            className="btn btn-secondary btn-small"
                                            type="button"
                                            onClick={() => setRoleFilters({ q: "", group: "", type: "", status: "", company: "", board: "" })}
                                        >
                                            Limpiar filtros
                                        </button>
                                    </div>

                                    <div className="form-grid">
                                        <Field label="Buscar" full>
                                            <input
                                                value={roleFilters.q}
                                                onChange={(e) => setRoleFilters({ ...roleFilters, q: e.target.value })}
                                                placeholder="Buscar rol, empresa, contacto, comité, email o notas..."
                                            />
                                        </Field>

                                        <Field label="Grupo">
                                            <select value={roleFilters.group} onChange={(e) => setRoleFilters({ ...roleFilters, group: e.target.value })}>
                                                <option value="">Todos</option>
                                                {roleFilterOptions.groups.map((g) => <option key={g} value={g}>{g}</option>)}
                                            </select>
                                        </Field>

                                        <Field label="Tipo">
                                            <select value={roleFilters.type} onChange={(e) => setRoleFilters({ ...roleFilters, type: e.target.value })}>
                                                <option value="">Todos</option>
                                                {roleFilterOptions.types.map((t) => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </Field>

                                        <Field label="Estatus">
                                            <select value={roleFilters.status} onChange={(e) => setRoleFilters({ ...roleFilters, status: e.target.value })}>
                                                <option value="">Todos</option>
                                                {roleFilterOptions.statuses.map((s) => <option key={s} value={s}>{s}</option>)}
                                            </select>
                                        </Field>

                                        <Field label="Empresa">
                                            <select value={roleFilters.company} onChange={(e) => setRoleFilters({ ...roleFilters, company: e.target.value })}>
                                                <option value="">Todas</option>
                                                {roleFilterOptions.companies.map((c) => <option key={c} value={c}>{c}</option>)}
                                            </select>
                                        </Field>

                                        <Field label="Consejo">
                                            <select value={roleFilters.board} onChange={(e) => setRoleFilters({ ...roleFilters, board: e.target.value })}>
                                                <option value="">Todos</option>
                                                <option value="1">Sí</option>
                                                <option value="0">No</option>
                                            </select>
                                        </Field>
                                    </div>
                                </div>

                                <div className="table-wrapper">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th><RoleSortHeader label="Grupo" sortKey="role_group" /></th>
                                                <th><RoleSortHeader label="Rol" sortKey="role_title" /></th>
                                                <th><RoleSortHeader label="Empresa / contacto" sortKey="company" /></th>
                                                <th><RoleSortHeader label="Tipo" sortKey="role_type" /></th>
                                                <th><RoleSortHeader label="Periodo" sortKey="period" /></th>
                                                <th><RoleSortHeader label="Consejo" sortKey="board" /></th>
                                                <th style={{ width: 120 }}><RoleSortHeader label="Archivos" sortKey="assets" /></th>
                                                <th style={{ width: 210 }}>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredRoles.map((r) => (
                                                <tr key={r.id}>
                                                    <td style={{ color: "#9fc4df", fontSize: 12 }}>
                                                        <div><strong>{r.role_group || "—"}</strong></div>
                                                        <div style={{ fontSize: 11 }}>{r.status || "activo"}</div>
                                                    </td>
                                                    <td>
                                                        <strong>{r.role_title}</strong>
                                                        {r.committee_area ? <div style={{ fontSize: 11, color: "#6b7280" }}>{r.committee_area}</div> : null}
                                                    </td>
                                                    <td style={{ fontSize: 12, color: "#9fc4df" }}>
                                                        <div>{r.affiliate_company_name || r.organization || "—"}</div>
                                                        <div>{r.contact_full_name || r.person_name || "—"}</div>
                                                    </td>
                                                    <td style={{ fontSize: 12, color: "#9fc4df" }}>
                                                        <div>{r.role_type || "—"}</div>
                                                        <div>{r.email || r.contact_email || "—"}</div>
                                                    </td>
                                                    <td style={{ fontSize: 12, color: "#9fc4df" }}>
                                                        <div>{r.period_start || "—"}</div>
                                                        <div>a {r.period_end || "—"}</div>
                                                    </td>
                                                    <td>{Number(r.is_board_member || 0) === 1 ? <span className="badge">Sí</span> : "No"}</td>
                                                    <td>
                                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                            {roleAssetsSummary?.[String(r.id)]?.first_image_path ? (
                                                                <img
                                                                    src={roleAssetsSummary[String(r.id)].first_image_path}
                                                                    alt="img"
                                                                    style={{ width: 34, height: 34, objectFit: "cover", borderRadius: 6, border: "1px solid #e5e7eb" }}
                                                                />
                                                            ) : (
                                                                <div style={{ width: 34, height: 34, borderRadius: 6, border: "1px solid #e5e7eb", display: "grid", placeItems: "center", color: "#9ca3af" }}>—</div>
                                                            )}
                                                            <div style={{ fontSize: 12, color: "#d7e8f6" }}>
                                                                {(roleAssetsSummary?.[String(r.id)]?.total ?? r.assets_count ?? 0)}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-actions">
                                                            <button className="btn btn-secondary btn-small" onClick={() => gotoRole(r.id)}>Detalles</button>
                                                            <button className="btn btn-secondary btn-small" onClick={() => openEditRole(r)}>Editar</button>
                                                            <button
                                                                className="btn btn-danger btn-small"
                                                                onClick={async () => {
                                                                    try { await apiDeleteRole(r.id); setToast({ type: "ok", msg: "Rol eliminado" }); }
                                                                    catch (e) { setToast({ type: "error", msg: e.message }); }
                                                                }}
                                                            >
                                                                Eliminar
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}

                                            {filteredRoles.length === 0 ? (
                                                <tr>
                                                    <td colSpan={8} style={{ textAlign: "center", color: "#6b7280", padding: 18 }}>
                                                        No hay roles que coincidan con los filtros actuales.
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                </Drawer>

                <Drawer open={panelParam === "documents"} title="Documentos · Detalles" subtitle="Consulta por documento o vista lista" onClose={() => setPanel(null)}>
                    <div className="card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>
                                {selectedDoc ? "Consulta (documento seleccionado)" : "Consulta (lista completa)"}
                            </h3>

                            <div className="form-actions">
                                {selectedDoc ? (
                                    <>
                                        <button className="btn btn-secondary" onClick={() => clearSelection("doc_id")}>Ver lista</button>
                                        <button className="btn btn-primary" onClick={openNewDoc}>Nuevo documento</button>
                                    </>
                                ) : (
                                    <button className="btn btn-primary" onClick={openNewDoc}>Nuevo documento</button>
                                )}
                            </div>
                        </div>

                        {selectedDoc ? (
                            <div style={{ display: "grid", gap: 6 }}>
                                <div><strong>ID:</strong> {selectedDoc.id}</div>
                                <div><strong>Título:</strong> {selectedDoc.title}</div>
                                <div><strong>Categoría:</strong> {selectedDoc.category}</div>
                                <div><strong>Archivo:</strong> {selectedDoc.file_name || "—"}</div>
                                <div><strong>Tipo:</strong> {selectedDoc.mime_type || "—"}</div>
                                {selectedDoc.description ? <div><strong>Descripción:</strong> {selectedDoc.description}</div> : null}

                                <div className="form-actions" style={{ marginTop: 8 }}>
                                    <a
                                        className="link-button"
                                        href={(selectedDoc.doc_type === "link" ? selectedDoc.url : selectedDoc.file_path) || "#"}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Abrir
                                    </a>

                                    <button
                                        className="btn btn-danger"
                                        onClick={async () => {
                                            try {
                                                await apiDeleteDoc(selectedDoc.id);
                                                setToast({ type: "ok", msg: "Documento eliminado" });
                                                clearSelection("doc_id");
                                            } catch (e) {
                                                setToast({ type: "error", msg: e.message });
                                            }
                                        }}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="table-wrapper">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Documento</th>
                                            <th>Categoría</th>
                                            <th style={{ width: 260 }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {docs.map((d) => {
                                            const href = d.doc_type === "link" ? d.url : d.file_path;
                                            return (
                                                <tr key={d.id}>
                                                    <td>
                                                        <strong>{fileIconByMime(d.mime_type)} {d.title}</strong>
                                                        <div style={{ fontSize: 12, color: "#9fc4df" }}>{d.file_name || ""}</div>
                                                    </td>
                                                    <td>{d.category}</td>
                                                    <td>
                                                        <div className="form-actions">
                                                            <button className="btn btn-secondary btn-small" onClick={() => gotoDoc(d.id)}>Detalles</button>
                                                            <a className="link-button" href={href || "#"} target="_blank" rel="noreferrer">Abrir</a>
                                                            <button
                                                                className="btn btn-danger btn-small"
                                                                onClick={async () => {
                                                                    try { await apiDeleteDoc(d.id); setToast({ type: "ok", msg: "Documento eliminado" }); }
                                                                    catch (e) { setToast({ type: "error", msg: e.message }); }
                                                                }}
                                                            >
                                                                Eliminar
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </Drawer>

                <Drawer open={panelParam === "events"} title="Eventos · Detalles" subtitle="Consulta por evento o vista lista" onClose={() => setPanel(null)}>
                    <div className="card">
                        <div className="card-header-inline">
                            <h3 className="card-title" style={{ margin: 0 }}>
                                {selectedEvent ? "Consulta (evento seleccionado)" : "Consulta (lista completa)"}
                            </h3>

                            <div className="form-actions">
                                {selectedEvent ? (
                                    <>
                                        <button className="btn btn-secondary" onClick={() => clearSelection("event_id")}>Ver lista</button>
                                        <button className="btn btn-primary" onClick={() => openEditEvent(selectedEvent)}>Editar</button>
                                    </>
                                ) : (
                                    <button className="btn btn-primary" onClick={openNewEvent}>Nuevo evento</button>
                                )}
                            </div>
                        </div>

                        {selectedEvent ? (
                            <>
                                <div style={{ display: "grid", gap: 6 }}>
                                    <div><strong>ID:</strong> {selectedEvent.id}</div>
                                    <div><strong>Fecha:</strong> {fmtDateISO(selectedEvent.event_date)}</div>
                                    <div><strong>Título:</strong> {selectedEvent.title || "—"}</div>
                                    <div><strong>Tipo:</strong> {selectedEvent.event_type || "—"}</div>
                                    <div><strong>Ubicación:</strong> {selectedEvent.location || "—"}</div>
                                    {selectedEvent.tags ? <div><strong>Tags:</strong> {selectedEvent.tags}</div> : null}
                                    {selectedEvent.reason ? <div><strong>Razón:</strong> {selectedEvent.reason}</div> : null}
                                    {selectedEvent.summary_text ? <div><strong>Resumen:</strong> {selectedEvent.summary_text}</div> : null}
                                </div>

                                <div className="form-actions" style={{ marginTop: 10 }}>
                                    <button
                                        className="btn btn-danger"
                                        onClick={async () => {
                                            try {
                                                await apiDeleteEvent(selectedEvent.id);
                                                setToast({ type: "ok", msg: "Evento eliminado" });
                                                clearSelection("event_id");
                                                setEventPhotos([]);
                                            } catch (e) {
                                                setToast({ type: "error", msg: e.message });
                                            }
                                        }}
                                    >
                                        Eliminar
                                    </button>
                                </div>

                                <div className="card" style={{ marginTop: 12 }}>
                                    <div className="card-header-inline">
                                        <h3 className="card-title" style={{ margin: 0 }}>Fotos del evento</h3>
                                        <span className="badge">{eventPhotos.length} foto(s)</span>
                                    </div>

                                    <div className="form-grid">
                                        <Field label="Imágenes" full>
                                            <input
                                                type="file"
                                                multiple
                                                accept="image/png,image/jpeg,image/webp"
                                                onChange={(e) => setEventPhotoFiles(Array.from(e.target.files || []))}
                                            />
                                            <div style={{ fontSize: 12, color: "#9fc4df" }}>
                                                {eventPhotoFiles.length ? `${eventPhotoFiles.length} seleccionado(s)` : "Selecciona imágenes"}
                                            </div>
                                        </Field>

                                        <Field label="Caption (opcional)" full>
                                            <input value={eventPhotoCaption} onChange={(e) => setEventPhotoCaption(e.target.value)} />
                                        </Field>

                                        <Field label="Tipo de foto" full>
                                            <select value={eventPhotoType} onChange={(e) => setEventPhotoType(e.target.value)}>
                                                {PHOTO_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
                                            </select>
                                        </Field>

                                        <div className="form-actions full-width">
                                            <button
                                                className="btn btn-primary"
                                                onClick={async () => {
                                                    try {
                                                        await apiUploadEventPhotos(selectedEvent.id);
                                                        setToast({ type: "ok", msg: "Fotos subidas" });
                                                    } catch (e) {
                                                        setToast({ type: "error", msg: e.message });
                                                    }
                                                }}
                                            >
                                                Subir fotos
                                            </button>

                                            <button
                                                className="btn btn-secondary"
                                                onClick={async () => {
                                                    try {
                                                        await loadEventPhotos(selectedEvent.id);
                                                        setToast({ type: "ok", msg: "Galería actualizada" });
                                                    } catch (e) {
                                                        setToast({ type: "error", msg: e.message });
                                                    }
                                                }}
                                            >
                                                Actualizar
                                            </button>
                                        </div>
                                    </div>

                                    {eventPhotos.length === 0 ? (
                                        <div className="alert-info">Este evento no tiene fotos aún.</div>
                                    ) : (
                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, minmax(0, 1fr))", gap: 10 }}>
                                            {eventPhotos.map((p) => (
                                                <div key={p.id} className="card" style={{ padding: 10 }}>
                                                    <a href={p.file_path} target="_blank" rel="noreferrer">
                                                        <img
                                                            src={p.file_path}
                                                            alt={p.caption || "foto"}
                                                            style={{ width: "100%", height: 110, objectFit: "cover", borderRadius: 8 }}
                                                        />
                                                    </a>
                                                    {p.photo_type ? <div style={{ fontSize: 12, color: "#666", marginTop: 6 }}>Tipo: {p.photo_type}</div> : null}
                                                    {p.caption ? <div style={{ fontSize: 12, marginTop: 6 }}>{p.caption}</div> : null}
                                                    <button
                                                        className="btn btn-danger btn-small"
                                                        style={{ width: "100%", marginTop: 8 }}
                                                        onClick={async () => {
                                                            try {
                                                                await apiDeleteEventPhoto(p.id);
                                                                setToast({ type: "ok", msg: "Foto eliminada" });
                                                            } catch (e) {
                                                                setToast({ type: "error", msg: e.message });
                                                            }
                                                        }}
                                                    >
                                                        Eliminar
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : (
                            <div className="table-wrapper">
                                <table className="table">
                                    <thead><tr><th>Fecha</th><th>Evento</th><th>Tipo</th><th style={{ width: 260 }}>Acciones</th></tr></thead>
                                    <tbody>
                                        {events.map((ev) => (
                                            <tr key={ev.id}>
                                                <td>{fmtDateISO(ev.event_date)}</td>
                                                <td><strong>{ev.title}</strong></td>
                                                <td style={{ color: "#9fc4df", fontSize: 12 }}>{ev.event_type || "—"}</td>
                                                <td>
                                                    <div className="form-actions">
                                                        <button className="btn btn-secondary btn-small" onClick={() => gotoEvent(ev.id)}>Detalles</button>
                                                        <button className="btn btn-secondary btn-small" onClick={() => openEditEvent(ev)}>Editar</button>
                                                        <button className="btn btn-danger btn-small" onClick={async () => {
                                                            try { await apiDeleteEvent(ev.id); setToast({ type: "ok", msg: "Evento eliminado" }); }
                                                            catch (e) { setToast({ type: "error", msg: e.message }); }
                                                        }}>Eliminar</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </Drawer>

                <Modal
                    open={modal?.kind === "edit_profile"}
                    title="Editar perfil institucional"
                    subtitle="Misión, visión, objetivos, contactos y redes"
                    onClose={() => setModal(null)}
                >
                    <div className="form-grid">
                        <Field label="Nombre" full>
                            <input
                                value={profileEditDraft?.org_name ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, org_name: e.target.value })}
                            />
                        </Field>

                        <Field label="Nombre corto">
                            <input
                                value={profileEditDraft?.short_name ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, short_name: e.target.value })}
                            />
                        </Field>

                        <Field label="Descripción / Tagline" full>
                            <input
                                value={profileEditDraft?.tagline ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, tagline: e.target.value })}
                            />
                        </Field>

                        <Field label="Misión" full>
                            <textarea
                                rows={4}
                                value={profileEditDraft?.mission ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, mission: e.target.value })}
                            />
                        </Field>

                        <Field label="Visión" full>
                            <textarea
                                rows={4}
                                value={profileEditDraft?.vision ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, vision: e.target.value })}
                            />
                        </Field>

                        <Field label="Objetivos" full>
                            <textarea
                                rows={5}
                                value={profileEditDraft?.objectives ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, objectives: e.target.value })}
                            />
                        </Field>

                        <Field label="Razones" full>
                            <textarea
                                rows={5}
                                value={profileEditDraft?.razones ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, razones: e.target.value })}
                            />
                        </Field>

                        <Field label="Website">
                            <input
                                value={profileEditDraft?.website ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, website: e.target.value })}
                            />
                        </Field>

                        <Field label="Correo">
                            <input
                                value={profileEditDraft?.email ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, email: e.target.value })}
                            />
                        </Field>

                        <Field label="Teléfono">
                            <input
                                value={profileEditDraft?.phone ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, phone: e.target.value })}
                            />
                        </Field>

                        <Field label="Facebook">
                            <input
                                value={profileEditDraft?.social_facebook ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, social_facebook: e.target.value })}
                            />
                        </Field>

                        <Field label="Instagram">
                            <input
                                value={profileEditDraft?.social_instagram ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, social_instagram: e.target.value })}
                            />
                        </Field>

                        <Field label="LinkedIn">
                            <input
                                value={profileEditDraft?.social_linkedin ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, social_linkedin: e.target.value })}
                            />
                        </Field>

                        <Field label="X / Twitter">
                            <input
                                value={profileEditDraft?.social_x ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, social_x: e.target.value })}
                            />
                        </Field>

                        <Field label="YouTube" full>
                            <input
                                value={profileEditDraft?.social_youtube ?? ""}
                                onChange={(e) => setProfileEditDraft({ ...profileEditDraft, social_youtube: e.target.value })}
                            />
                        </Field>

                        <div className="form-actions full-width">
                            <button
                                className="btn btn-primary"
                                onClick={async () => {
                                    try {
                                        await apiUpdateProfile(profileEditDraft);
                                        setToast({ type: "ok", msg: "Perfil guardado" });
                                        setModal(null);
                                    } catch (e) {
                                        setToast({ type: "error", msg: e.message });
                                    }
                                }}
                            >
                                Guardar
                            </button>
                            <button className="btn btn-secondary" onClick={() => setModal(null)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    open={modal?.kind === "new_industry"}
                    title="Nuevo eje / industria"
                    subtitle="Crear un nuevo eje"
                    onClose={() => setModal(null)}
                >
                    <div className="form-grid">
                        <Field label="Nombre" full>
                            <input value={industryDraft.name} onChange={(e) => setIndustryDraft({ ...industryDraft, name: e.target.value })} />
                        </Field>

                        <Field label="Descripción" full>
                            <textarea rows={3} value={industryDraft.description} onChange={(e) => setIndustryDraft({ ...industryDraft, description: e.target.value })} />
                        </Field>

                        <div className="form-actions full-width">
                            <button className="btn btn-primary" onClick={async () => {
                                try {
                                    await apiCreateIndustry(industryDraft);
                                    setToast({ type: "ok", msg: "Eje creado" });
                                    setModal(null);
                                } catch (e) {
                                    setToast({ type: "error", msg: e.message });
                                }
                            }}>Crear</button>

                            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    open={modal?.kind === "edit_industry"}
                    title="Editar eje / industria"
                    subtitle="Actualiza el eje y administra sus sectores"
                    onClose={() => setModal(null)}
                    size="wide"
                >
                    <div className="form-grid">
                        <Field label="Nombre" full>
                            <input value={industryEditDraft?.name ?? ""} onChange={(e) => setIndustryEditDraft({ ...industryEditDraft, name: e.target.value })} />
                        </Field>

                        <Field label="Descripción" full>
                            <textarea rows={3} value={industryEditDraft?.description ?? ""} onChange={(e) => setIndustryEditDraft({ ...industryEditDraft, description: e.target.value })} />
                        </Field>

                        <div
                            className="card full-width"
                            style={{
                                marginTop: 8,
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}
                        >
                            <div className="card-header-inline">
                                <div>
                                    <h3 className="card-title" style={{ margin: 0 }}>Sectores</h3>
                                    <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
                                        {industryEditDraft?.name ? `Industria seleccionada: ${industryEditDraft.name}` : "Selecciona un eje / industria"}
                                    </div>
                                </div>
                                <div className="form-actions">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={async () => {
                                            const next = !showSectionsBlock;
                                            setShowSectionsBlock(next);
                                            if (next && industryEditDraft?.id) {
                                                await loadIndustrySections(industryEditDraft.id);
                                            }
                                        }}
                                    >
                                        {showSectionsBlock ? "Ocultar" : "Mostrar"}
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            setSectionDraft({ title: "", description: "" });
                                            setSectionEditDraft(null);
                                            setShowSectionsBlock(true);
                                        }}
                                    >
                                        Agregar sector
                                    </button>
                                </div>
                            </div>

                            {!showSectionsBlock ? (
                                <div style={{ color: "#9fc4df" }}>—</div>
                            ) : (
                                <>
                                    {sectionsLoading ? <div>Cargando sectores…</div> : null}
                                    {sectionsError ? <div className="alert-info">{sectionsError}</div> : null}

                                    <div className="form-grid" style={{ width: "100%", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)", alignItems: "start" }}>
                                        <Field label="Título" full>
                                            <input
                                                value={(sectionEditDraft ? sectionEditDraft.title : sectionDraft.title) || ""}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    sectionEditDraft
                                                        ? setSectionEditDraft({ ...sectionEditDraft, title: v })
                                                        : setSectionDraft({ ...sectionDraft, title: v });
                                                }}
                                            />
                                        </Field>

                                        <Field label="Descripción" full>
                                            <textarea
                                                rows={2}
                                                value={(sectionEditDraft ? sectionEditDraft.description : sectionDraft.description) || ""}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    sectionEditDraft
                                                        ? setSectionEditDraft({ ...sectionEditDraft, description: v })
                                                        : setSectionDraft({ ...sectionDraft, description: v });
                                                }}
                                            />
                                        </Field>

                                        <div className="form-actions full-width">
                                            <button
                                                className="btn btn-primary"
                                                onClick={async () => {
                                                    try {
                                                        if (!industryEditDraft?.id) return;

                                                        if (sectionEditDraft?.id) {
                                                            await updateIndustrySection({
                                                                id: sectionEditDraft.id,
                                                                title: sectionEditDraft.title,
                                                                description: sectionEditDraft.description,
                                                            });
                                                            setToast({ type: "ok", msg: "Sector actualizado" });
                                                            setSectionEditDraft(null);
                                                        } else {
                                                            await createIndustrySection(industryEditDraft.id, sectionDraft);
                                                            setToast({ type: "ok", msg: "Sector creado" });
                                                            setSectionDraft({ title: "", description: "" });
                                                        }

                                                        await loadIndustrySections(industryEditDraft.id);
                                                        await loadIndustrySectionCounts();
                                                    } catch (e) {
                                                        setToast({ type: "error", msg: e.message });
                                                    }
                                                }}
                                            >
                                                {sectionEditDraft ? "Guardar sector" : "Crear sector"}
                                            </button>

                                            {sectionEditDraft ? (
                                                <button className="btn btn-secondary" onClick={() => setSectionEditDraft(null)}>
                                                    Cancelar edición
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="table-wrapper full-width" style={{ marginTop: 10, width: "100%", gridColumn: "1 / -1" }}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 220 }}>Título</th>
                                                    <th>Descripción</th>
                                                    <th style={{ width: 220 }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {industrySections.map((s) => (
                                                    <tr key={s.id}>
                                                        <td><strong>{s.title}</strong></td>
                                                        <td><div style={{ fontSize: 12, color: "#6b7280" }}>{s.description || "—"}</div></td>
                                                        <td>
                                                            <div className="form-actions">
                                                                <button className="btn btn-secondary btn-small" onClick={() => setSectionEditDraft({ ...s })}>
                                                                    Editar
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger btn-small"
                                                                    onClick={async () => {
                                                                        try {
                                                                            await deleteIndustrySection(s.id);
                                                                            setToast({ type: "ok", msg: "Sector eliminado" });
                                                                            await loadIndustrySections(industryEditDraft.id);
                                                                            await loadIndustrySectionCounts();
                                                                        } catch (e) {
                                                                            setToast({ type: "error", msg: e.message });
                                                                        }
                                                                    }}
                                                                >
                                                                    Eliminar
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}

                                                {industrySections.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={3} style={{ color: "#9fc4df" }}>Sin sectores aún.</td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="form-actions full-width">
                            <button className="btn btn-primary" onClick={async () => {
                                try {
                                    await apiUpdateIndustry(industryEditDraft);
                                    setToast({ type: "ok", msg: "Eje actualizado" });
                                    await loadIndustries();
                                } catch (e) {
                                    setToast({ type: "error", msg: e.message });
                                }
                            }}>Guardar eje</button>

                            <button
                                className="btn btn-secondary"
                                onClick={async () => {
                                    const next = !showSectionsBlock;
                                    setShowSectionsBlock(next);
                                    if (next && industryEditDraft?.id) {
                                        await loadIndustrySections(industryEditDraft.id);
                                    }
                                }}
                            >
                                {showSectionsBlock ? "Ocultar sectores" : "Mostrar sectores"}
                            </button>

                            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cerrar</button>
                        </div>
                    </div>
                </Modal>

                <Modal open={modal?.kind === "new_doc"} title="Nuevo documento" subtitle="Subir archivo" onClose={() => setModal(null)}>
                    <div className="form-grid">
                        <Field label="Categoría">
                            <select value={docDraft.category} onChange={(e) => setDocDraft({ ...docDraft, category: e.target.value })}>
                                {DOC_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </Field>

                        <Field label="Título" full>
                            <input value={docDraft.title} onChange={(e) => setDocDraft({ ...docDraft, title: e.target.value })} />
                        </Field>

                        <Field label="Orden">
                            <input type="number" value={docDraft.sort_order} onChange={(e) => setDocDraft({ ...docDraft, sort_order: Number(e.target.value || 0) })} />
                        </Field>

                        <Field label="Descripción" full>
                            <textarea rows={2} value={docDraft.description} onChange={(e) => setDocDraft({ ...docDraft, description: e.target.value })} />
                        </Field>

                        <Field label="Archivo" full>
                            <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg,.webp" onChange={(e) => setDocFile(e.target.files?.[0] || null)} />
                            <div style={{ fontSize: 12, color: "#9fc4df" }}>{docFile ? docFile.name : "Selecciona un archivo"}</div>
                        </Field>

                        <div className="form-actions full-width">
                            <button className="btn btn-primary" onClick={async () => {
                                try { await apiUploadDoc(); setToast({ type: "ok", msg: "Documento subido" }); setModal(null); }
                                catch (e) { setToast({ type: "error", msg: e.message }); }
                            }}>Subir</button>
                            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                        </div>
                    </div>
                </Modal>

                <Modal open={modal?.kind === "new_role"} title="Nuevo rol institucional" subtitle="Estructura CLIP" onClose={() => setModal(null)} size="wide">
                    <div className="form-grid">
                        {renderRoleProFields(roleDraft, setRoleDraft, false)}

                        <Field label="Documento del plan (archivo)">
                            <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx" onChange={(e) => setRolePlanFile(e.target.files?.[0] || null)} />
                        </Field>

                        <Field label="Imagen certificado/nombramiento (archivo)">
                            <input type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => setRoleCertFile(e.target.files?.[0] || null)} />
                        </Field>

                        <div className="form-actions full-width">
                            <button className="btn btn-primary" onClick={async () => {
                                try {
                                    const created = await apiCreateRole(roleDraft);
                                    const roleId = created?.id;

                                    let planPath = "";
                                    let certPath = "";
                                    if (roleId && rolePlanFile) planPath = await apiUploadRolePlan(roleId, rolePlanFile);
                                    if (roleId && roleCertFile) certPath = await apiUploadRoleCertificate(roleId, roleCertFile);

                                    if (roleId && (planPath || certPath)) {
                                        await apiUpdateRole({ ...roleDraft, id: roleId, plan_doc_path: planPath, certificate_image_path: certPath });
                                    }

                                    await loadInstitutionRoles();
                                    setToast({ type: "ok", msg: "Rol institucional creado" });
                                    setModal(null);
                                } catch (e) {
                                    setToast({ type: "error", msg: e.message });
                                }
                            }}>Crear</button>

                            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                        </div>

                        <div className="alert-info full-width">
                            La empresa debe tener estatus de afiliada y el contacto debe estar vinculado desde Afiliaciones / Ficha 360.
                        </div>
                    </div>
                </Modal>

                <Modal open={modal?.kind === "edit_role"} title="Editar rol institucional" subtitle="Estructura CLIP" onClose={() => setModal(null)} size="wide">
                    <div className="form-grid">
                        {renderRoleProFields(roleEditDraft, setRoleEditDraft, true)}

                        <Field label="Documento del plan (archivo)">
                            <input type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx" onChange={(e) => setRolePlanFile(e.target.files?.[0] || null)} />
                        </Field>

                        <Field label="Imagen certificado/nombramiento (archivo)">
                            <input type="file" accept="image/png,image/jpeg,image/webp" onChange={(e) => setRoleCertFile(e.target.files?.[0] || null)} />
                        </Field>

                        <div className="form-actions full-width">
                            <button className="btn btn-primary" onClick={async () => {
                                try {
                                    let planPath = "";
                                    let certPath = "";
                                    if (roleEditDraft?.id && rolePlanFile) planPath = await apiUploadRolePlan(roleEditDraft.id, rolePlanFile);
                                    if (roleEditDraft?.id && roleCertFile) certPath = await apiUploadRoleCertificate(roleEditDraft.id, roleCertFile);

                                    await apiUpdateRole({
                                        ...roleEditDraft,
                                        plan_doc_path: planPath || roleEditDraft?.plan_doc_path,
                                        certificate_image_path: certPath || roleEditDraft?.certificate_image_path,
                                    });

                                    await loadInstitutionRoles();
                                    setToast({ type: "ok", msg: "Rol institucional actualizado" });
                                    setModal(null);
                                } catch (e) {
                                    setToast({ type: "error", msg: e.message });
                                }
                            }}>Guardar</button>

                            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                        </div>
                    </div>
                </Modal>

                <Modal open={modal?.kind === "new_event"} title="Nuevo evento" subtitle="Crear evento" onClose={() => setModal(null)}>
                    <div className="form-grid">
                        <Field label="Fecha"><input value={eventEditDraft?.event_date ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, event_date: e.target.value })} /></Field>

                        <Field label="Tipo">
                            <select value={eventEditDraft?.event_type ?? EVENT_TYPES[0]} onChange={(e) => setEventEditDraft({ ...eventEditDraft, event_type: e.target.value })}>
                                {EVENT_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </Field>

                        <Field label="Título" full><input value={eventEditDraft?.title ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, title: e.target.value })} /></Field>

                        <Field label="Ubicación" full><input value={eventEditDraft?.location ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, location: e.target.value })} /></Field>

                        <Field label="Tags" full><input value={eventEditDraft?.tags ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, tags: e.target.value })} /></Field>

                        <Field label="Razón" full><textarea rows={2} value={eventEditDraft?.reason ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, reason: e.target.value })} /></Field>

                        <Field label="Resumen" full><textarea rows={4} value={eventEditDraft?.summary_text ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, summary_text: e.target.value })} /></Field>

                        <div className="form-actions full-width">
                            <button className="btn btn-secondary" onClick={genSummaryIntoEventEditDraft}>Generar resumen</button>
                            <button className="btn btn-primary" onClick={async () => {
                                try { await apiCreateEvent(eventEditDraft); setToast({ type: "ok", msg: "Evento creado" }); setModal(null); }
                                catch (e) { setToast({ type: "error", msg: e.message }); }
                            }}>Crear</button>
                            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                        </div>
                    </div>
                </Modal>

                <Modal open={modal?.kind === "edit_event"} title="Editar evento" subtitle="Modificar evento seleccionado" onClose={() => setModal(null)}>
                    <div className="form-grid">
                        <Field label="Fecha"><input value={eventEditDraft?.event_date ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, event_date: e.target.value })} /></Field>

                        <Field label="Tipo">
                            <select value={eventEditDraft?.event_type ?? EVENT_TYPES[0]} onChange={(e) => setEventEditDraft({ ...eventEditDraft, event_type: e.target.value })}>
                                {EVENT_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </Field>

                        <Field label="Título" full><input value={eventEditDraft?.title ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, title: e.target.value })} /></Field>

                        <Field label="Ubicación" full><input value={eventEditDraft?.location ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, location: e.target.value })} /></Field>

                        <Field label="Tags" full><input value={eventEditDraft?.tags ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, tags: e.target.value })} /></Field>

                        <Field label="Razón" full><textarea rows={2} value={eventEditDraft?.reason ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, reason: e.target.value })} /></Field>

                        <Field label="Resumen" full><textarea rows={4} value={eventEditDraft?.summary_text ?? ""} onChange={(e) => setEventEditDraft({ ...eventEditDraft, summary_text: e.target.value })} /></Field>

                        <div className="form-actions full-width">
                            <button className="btn btn-secondary" onClick={genSummaryIntoEventEditDraft}>Generar resumen</button>
                            <button className="btn btn-primary" onClick={async () => {
                                try { await apiUpdateEvent(eventEditDraft); setToast({ type: "ok", msg: "Evento actualizado" }); setModal(null); }
                                catch (e) { setToast({ type: "error", msg: e.message }); }
                            }}>Guardar</button>
                            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                        </div>
                    </div>
                </Modal>

                {toast ? (
                    <div className="card" style={{ position: "fixed", right: 16, bottom: 16, maxWidth: 560, zIndex: 3000 }}>
                        <div style={{ fontWeight: 700, marginBottom: 6 }}>{toast.type === "error" ? "Error" : "OK"}</div>
                        <div style={{ color: "#d7e8f6" }}>{toast.msg}</div>
                    </div>
                ) : null}
            </div>
        </MainLayout>
    );
}
